import { CODE_PAUSE } from '@/data/constant'
import { translateTemplateWay } from '@/data/i18n/json/templateMap'
import { translateCustomTag, translateLang } from '@/data/i18n/translateLang'
import { genCCWSideHoleSlot } from '@/util/LayoutFuncs.js'
import { dealHighlightMatCode, judgeRectangle } from '@/util/commonFun'
import {
  fourTrimEdge,
  getOtherSideMachineTargets,
  handleJxEdge,
  toDecimal,
} from '@/util/commonFuncs'
import { getPlateKnifeDiameter } from '@/util/dealPaibanData'
import defaultTagData from '@/util/defaultTagData'
import { getDeviceXDPI, mmToPx, pxTomm } from '@/util/exportFuncs'
import {
  dealPathByNCSetting,
  genHandleSlopesStr,
  getEdgeLengthsFromLShape,
  getPathMinMaxPoint,
  getPlankMatCodeByNotHigh,
  isLShapeSurplusBigPlank,
  isSpecialShapeSurplusBigPlank,
} from '@/util/plankCommonFuncs'
import { buildCutSurplusRestockingQrPlankInfo } from '@/util/surplusWarehousing'
import {
  dealNotchDir,
  dealSizeNum,
  getEdgeValue,
  getPaibanTime,
  getSurplusSize,
} from '@/util/tag'
import { getGraghEdge } from '@/util/tag'
import rollLShapePlank, { dealSurplusPlank } from '@/util/tag/pdf-draw'
import {
  fitEdgeTextToWidth,
  isPhysicalLeftOrRightEdge,
} from '@/util/tag/physicalEdge'
import {
  dealTextStr,
  drawFormerEdge,
  drawLightSign,
  drawOpenDoor,
  drawPartHoleSlot,
  drawSideMachiningSequenceDiagram,
  drawSpecialSign,
  drawTagText,
  fabricTable,
  getTagFontFamily,
  getTagImageByResolution,
  handleOpenDoorDistance,
  initDrawData,
} from '@/util/tag/tag-draw'
import {
  alignTypographyToTemplateOrigin,
  constrainTypographyToCanvas,
  fitTypographyBounds,
  getTypographyEditorBounds,
  preserveTypographyTextScale,
} from '@/util/tag/typographyPosition'
import { transformData } from '@/views/newPaiban/util/transformData'
import BwipJs from 'bwip-js'
import JsBarcode from 'jsbarcode'
import { cloneDeep } from 'lodash'
import QRCode from 'qrcode'

import store from '../store'
import { appendPreMillingToEdgeInfoDisplay } from './LayoutFuncs'
import { transformToEzSort } from './connect-color-label/transform'

let NC_SETTING = {}
let JX_CHECKED = false
let FIVE_SIX_DIR = false
let CONFIG = {}
// 是否需要旋转，自定义模板不包含这个属性
let isRotatePlank = false
const DPI = getDeviceXDPI()
let ALLSURPLUSLIST = []
const isOneCodeShouldToSvg = true
let TRIM_SIDE = ''
let GEN_PART_COLOR_REVERT
let TEXTCOLOR = '#000'
// 获取svg里面的所有的g标签
function getSvgAllGTag(svg) {
  let reg = /<g(\S|\s)*?<\/g>/g
  return svg.match(reg)
}

let configScale = 1
// 对尺寸进行缩放
function scaleSize(size) {
  return size * configScale
}

/**
 * 与 toDataURL({ multiplier }) 保持一致。
 * 条码/二维码是位图，若按画布分辨率生成后再被 multiplier 放大插值，黑条会发糊、发粗。
 * 因此按该倍数预生成位图，放置时再等比缩小。
 */
const TAG_EXPORT_MULTIPLIER = 2
/** 一维码模块宽度：显示宽度 / 该值（历史魔法数，勿随意改） */
const ONECODE_MODULE_DIVISOR = 120

function getOnecodeJsBarcodeOptions(info, arrPI) {
  const displayW = scaleSize(mmToPx(info.mWidth, arrPI))
  const displayH = scaleSize(mmToPx(info.mHeight, arrPI))
  return {
    format: info.code_type.toUpperCase(),
    width: (displayW / ONECODE_MODULE_DIVISOR) * TAG_EXPORT_MULTIPLIER,
    height: displayH * TAG_EXPORT_MULTIPLIER,
    margin: 0,
    displayValue: false,
  }
}

function getOnecodeImageScale() {
  return {
    scaleX: 1 / TAG_EXPORT_MULTIPLIER,
    scaleY: 0.75 / TAG_EXPORT_MULTIPLIER,
  }
}

function getQrCodeGenSize(info, arrPI) {
  const displayW = scaleSize(mmToPx(info.mWidth, arrPI))
  const displayH = scaleSize(mmToPx(info.mHeight, arrPI))
  return {
    displayW,
    displayH,
    width: displayW * TAG_EXPORT_MULTIPLIER,
    height: displayH * TAG_EXPORT_MULTIPLIER,
  }
}

/**
 * @description 生成标签
 * @param template 模板数据
 * @param plank 大板信息
 * @param part 小板信息
 * @param plank_index 第几张大板
 * @param part_index 第几张小板 从0开始
 * @param total_part 小板总数
 * @param jx_checked 标签图镜像
 * @param five_six_dir 五六面钻放板基准
 * @param config 配置（放大倍数 scale, 画布颜色 backgroundColor）
 * @param nc_setting this.$store.state.ncSetting
 * @param showCutTag 是否显示裁剪余料标签
 * @param {Object} [options={}] 选项
 * @param {'preview' | 'export'} [options.genTagWay='preview'] 生成标签的模式
 */
function createTag(
  template,
  plank,
  part,
  plank_index,
  part_index,
  total_part,
  jx_checked,
  five_six_dir,
  config = {},
  nc_setting,
  currentPlank,
  collect,
  sort_value,
  isTemp,
  showCutTag,
  rotatePlank,
  label_num,
  options = {
    genTagWay: 'export',
  }
) {
  // 参数太多了，再加参数，担心影响到其他地方使用
  const { roomNameMap: roomAndCabinetMap } = template
  // 存储自定义特殊标签信息的列表
  const specialMarkParList = []

  const { tag_opacity: tagOpacity } = store.state.userPermissions

  if (currentPlank) {
    const { size } = getGraghEdge(plank)
    plank.plankSize = size
  }
  isRotatePlank = rotatePlank
  // 余料板件单独处理
  if (part.specialType == 'supplus' && template.type !== 'plank') {
    ALLSURPLUSLIST = template.allSurplusList ?? []
    if (showCutTag) {
      return new_createLaveTag(
        template,
        part,
        plank,
        plank_index,
        total_part,
        config,
        nc_setting,
        collect,
        label_num
      )
    } else {
      return
    }
  }
  CONFIG = initConfig(config)
  NC_SETTING = JSON.parse(JSON.stringify(nc_setting)) || {}
  if (isTemp) {
    NC_SETTING.xyReverse = false
  }
  JX_CHECKED = jx_checked
  FIVE_SIX_DIR = five_six_dir
  const PRINT_COLOR_TAG = template.print_color_tag ?? false
  const judgeLimit = template.judgeLimit ?? true
  TRIM_SIDE = config.trimSide
  // 小板标签反色
  GEN_PART_COLOR_REVERT = template.gen_part_color_revert
  // 字体颜色默认是黑色 标签反色后为白色
  TEXTCOLOR = template.gen_part_color_revert ? '#fff' : '#000'

  let rectL = template.rectInfo.left
  let rectT = template.rectInfo.top
  let arrPI = getDeviceXDPI()
  // 初始化绘制数据
  initDrawData(CONFIG, NC_SETTING)
  let backgroundColor = CONFIG.backgroundColor
  // 标签反色后 标签背景色置为黑色
  if (GEN_PART_COLOR_REVERT) {
    backgroundColor = '#000'
  }
  let my_canvas = new fabric.StaticCanvas(CONFIG.canvas, {
    width: scaleSize(mmToPx(template.tag_width, arrPI)),
    height: scaleSize(mmToPx(template.tag_height, arrPI)),
    backgroundColor,
  })
  // 计算缩放值-大板标签进行整体缩放
  const scaleW = template.tag_width / 60
  const scaleH = template.tag_height / 40
  let finalScale = 1
  if (scaleW === scaleH) {
    finalScale = scaleW
  } else if (scaleW > scaleH) {
    finalScale = scaleH
  } else {
    finalScale = scaleW
  }

  // 大板标签等比例缩放
  if (template.type === 'plank') {
    my_canvas.setZoom(finalScale)
  }
  // 双面加工大板标签添加翻面标识
  if (template.type === 'plank' && plank.ableToggle) {
    let circle = new fabric.Circle({
      top: 70 * CONFIG.scale,
      left: 130 * CONFIG.scale,
      radius: 15 * CONFIG.scale, //圆形半径
      fill: '#fff', //填充的颜色
      stroke: '#000', // 边框颜色
      strokeWidth: 2, // 边框大小
    })
    let circle_text = new fabric.Text('翻', {
      top: 78 * CONFIG.scale,
      left: 138.5 * CONFIG.scale,
      fontSize: 14 * CONFIG.scale,
    })
    my_canvas.add(circle)
    my_canvas.add(circle_text)
  }

  // 正反面孔
  let holes = part.holes
  // 正反面槽
  let slots = part.slots
  // 所有的孔槽
  const allHoleSlot = [...holes, ...slots]
  // 正面孔
  let frontH = holes.filter((v) => {
    return Number(v.side) === 1
  }).length
  // 背面孔
  let backH = holes.filter((v) => {
    return Number(v.side) === -1
  }).length
  // 侧孔
  let sholesL = part.sholes?.length
  // 正面槽
  let fSlots = part.slots.filter((v) => {
    return Number(v.side) === 1
  }).length
  // 背面槽
  let bSlots = part.slots?.filter((item) => {
    return Number(item.side) === -1
  }).length
  // 侧槽
  let sSlots = part.sslots?.length
  // 排版图的旋转数据 用于见光边标识绘制 前封边标识绘制
  let rotateDeg =
    template.tem_data.filter((v) => v.type === 'Typography')?.[0]?.data
      ?.rotateDeg || 0

  // 存放是否有设置自定义五六面钻放板基准
  const isHasSixSideDrillPlankBase = template.tem_data.some((item) =>
    ['sixSideDrillArrow', 'sixSideDrillTriangle'].includes(item.type)
  )
  const sideDiagramPromises = []
  template.tem_data.forEach((item) => {
    let info = item.data
    let hasMoreThanAscii = false

    switch (item.type) {
      case 'holeSlotPicture':
        drawPartHoleSlot(
          my_canvas,
          part,
          rectL,
          rectT,
          info,
          {
            tempData: template.tem_data,
            gen_part_color_revert: GEN_PART_COLOR_REVERT,
          },
          JX_CHECKED
        )
        break
      case 'sideMachiningSequenceDiagram': {
        const p = drawSideMachiningSequenceDiagram(
          my_canvas,
          part,
          rectL,
          rectT,
          info,
          {
            tempData: template.tem_data,
            gen_part_color_revert: GEN_PART_COLOR_REVERT,
            jx_checked: JX_CHECKED,
          }
        )
        if (p) sideDiagramPromises.push(p)
        break
      }
      case 'FixedText': {
        const fixedText = info.text
        let fixedLeft = (info.left - rectL) * CONFIG.scale
        let fixedTop = (info.top - rectT) * CONFIG.scale
        const newInfo = JSON.parse(JSON.stringify(info))
        Object.assign(newInfo, { left: fixedLeft, top: fixedTop })
        // 标签反色后 二维码加了10的白色背景 所以安装图需要往下调
        if (fixedText === '安装图' && GEN_PART_COLOR_REVERT) {
          newInfo.top += 10
        }
        drawTagText(my_canvas, translateTemplateWay(fixedText), newInfo, {
          color: TEXTCOLOR,
          tagOpacity: tagOpacity,
        })
        break
      }
      case 'Graphics': {
        let points = info.points
        let newPoints = points.map((point) => {
          return {
            x: scaleSize(point.x - rectL),
            y: scaleSize(point.y - rectT),
          }
        })
        let Polygon = new fabric.Polygon(newPoints, {
          top: scaleSize(info.top - rectT),
          left: scaleSize(info.left - rectL),
          fill: !GEN_PART_COLOR_REVERT ? info.fill : '#fff',
          scaleX: info.scaleX,
          scaleY: info.scaleY,
          angle: info.angle,
          originX: 'center',
          originY: 'center',
          selectable: false,
        })
        my_canvas.add(Polygon)
        break
      }
      case 'specialMark':
        // 自定义特殊标记比率 为什么是0.8 因为特殊标签默认高宽为37  50 / 37 = 0.8
        const [custSpeciialTagratioX, custSpeciialTagratioY] = [
          scaleSize(0.8 * info.scaleX),
          scaleSize(0.8 * info.scaleY),
        ]
        const left = scaleSize(info.left - rectL)
        const top = scaleSize(info.top - rectT)
        const opacity = info.opacity
        // 组装参数 标签模板和柜柜跳转至此的情况都需要展示自定义特殊标签
        specialMarkParList.push({
          my_canvas,
          sign: part.specialFlag ?? part.specTagTemplate,
          template,
          opacity,
          sizeAuto: undefined,
          size: undefined,
          op: { left, top, custSpeciialTagratioX, custSpeciialTagratioY },
        })
        break
      // 绘制数据部分
      case 'DataSource': {
        let text = ''
        // 绘制大板
        if (template.type === 'plank') {
          // 获取到对应的text
          if (info.source_data === 'ncName') {
            text = plank.isGenNcSuffix
              ? plank.plankDrawMsg[info.source_data]
              : plank.plankDrawMsg[info.source_data].slice(
                  0,
                  plank.plankDrawMsg[info.source_data].lastIndexOf('.')
                )
          } else if (info.source_data == 'trim') {
            const surplusInfo = plank.surplusInfo
            const isPlus = surplusInfo?.is_plus
            let plankMargin = plank.margin
            if (surplusInfo && isPlus) {
              // 大板 修边值
              plankMargin = plank.isUseSaw
                ? plank.margin
                : store.state.selectStandardPlank.plankEdgeOff
            }

            let margin = fourTrimEdge(plankMargin, NC_SETTING, true)
            margin = handleJxEdge(margin, JX_CHECKED)
            if (String(margin)?.includes(',')) {
              const trimEdgeArr = String(margin).split(',')
              text = `上${trimEdgeArr[0]}-下${trimEdgeArr[1]}-左${trimEdgeArr[2]}-右${trimEdgeArr[3]}`
            } else {
              text = String(margin ?? '')
            }
          } else if (info.source_data === 'lable_index') {
            text = `第${label_num + 1}/${total_part}页`
          } else {
            text = plank.plankDrawMsg[info.source_data]
          }
          if (['size'].includes(info.source_data)) {
            const textArr = text.split('*')
            text = `${textArr[1]}*${textArr[0]}*${textArr[2]}`
          }
        } else {
          text = countSourceData(
            part,
            plank,
            plank_index,
            total_part,
            template,
            my_canvas,
            info,
            label_num,
            options
          )
        }
        if (!text) break

        let textC = new fabric.Text(text, {
          fontSize: scaleSize(info.fontSize),
        })
        const { text: str, fontSize: fts } = dealTextStr(
          text,
          info.fontSize,
          info.rectWidth ?? 80,
          info.rectHeight ?? 11.3,
          info.isAutoFontSize ?? true,
          info.lineCount ?? ''
        )
        let Itext = new fabric.Text(translateTemplateWay(str), {
          fontSize: scaleSize(fts),
          selectable: false,
          fontWeight: info.fontWeight,
          left: scaleSize(info.left - rectL),
          top: scaleSize(info.top - rectT),
          fontFamily: getTagFontFamily(info.fontFamily) ?? '微软雅黑',
          lineHeight: info.lineHeight ?? 1,
          opacity: tagOpacity ? info.opacity ?? 1 : 1,
          fill: TEXTCOLOR,
        })
        my_canvas.add(Itext)
        break
      }
      // 二维码
      case 'QRcode': {
        let url = ''
        if (template.type === 'plank') {
          // 绘制大板
          url = !(info.source_data === 'qrCode' && !plank.isGenNcSuffix)
            ? plank.plankDrawMsg[info.source_data]
            : plank.plankDrawMsg[info.source_data].slice(
                0,
                plank.plankDrawMsg[info.source_data].lastIndexOf('.')
              )
        } else {
          // 有反面标签
          if (info.source_data === 'plankNum') {
            if (frontH || sholesL || fSlots) url = part[info.source_data]
          } else if (info.source_data === 'oriPlankNum') {
            if (info.showCode) url = part[info.source_data]
            else if (
              frontH ||
              backH ||
              sholesL ||
              (slots && slots.length) ||
              sSlots
            )
              url = part.oriPlankNum
          } else if (info.source_data === 'ggid') {
            url = part['ggid']
          } else if (
            info.source_data === 'remarks' ||
            info.source_data === 'remark'
          ) {
            if (!!part[info.source_data]) {
              hasMoreThanAscii = [...part[info.source_data]].some(
                (char) => char.charCodeAt(0) > 127
              )
              let text = ''
              url = part[info.source_data]
              if (
                (hasMoreThanAscii || part[info.source_data].length > 50) &&
                false
              ) {
                url = ''
                text = '不支持该数据'
                let Itext = new fabric.Text(text, {
                  fontSize: scaleSize(info.fontSize),
                  selectable: false,
                  fontWeight: info.fontWeight,
                  left: scaleSize(info.left - rectL),
                  top: scaleSize(info.top - rectT),
                  fontFamily: getTagFontFamily(info.fontFamily) ?? '微软雅黑',
                  fontSize: 18,
                  rectWidth: info.rectWidth ?? 80,
                  rectHeight: info.rectHeight ?? 11.3,
                })
                my_canvas.add(Itext)
              }
            }
          } else if (info.source_data === 'ncName') {
            url = info.isQRcodeNCSuffix
              ? part.ncName
              : part.ncName.substring(0, part.ncName.lastIndexOf('.'))
          } else if (info.source_data === 'plankNumF') {
            if (backH || bSlots) url = part.oriPlankNumF
          } else if (info.source_data === 'size') {
            const { thick } = part
            let { height, width } = part['oRect']
            if (nc_setting.xyReverse) {
              ;[width, height] = [height, width]
            }
            url = `A${height}-B${width}-C${thick}`
          } else if (info.source_data === 'simplePlankNum') {
            if (!nc_setting.genSimpleLabelBarcode) break
            url = part.simplePlankNum
          } else if (info.source_data === 'hingeEquipment') {
            url = part.hingeEquipment ?? ''
          } else {
            url = part?.[info.source_data]
          }
        }
        if (!url) break
        // 开启小板标签反色时
        let bgRect
        if (GEN_PART_COLOR_REVERT) {
          // 创建白色背景矩形（尺寸比图像稍大）
          bgRect = new fabric.Rect({
            width: scaleSize(mmToPx(info.mWidth, arrPI)) + 10,
            height: scaleSize(mmToPx(info.mHeight, arrPI)) + 10,
            top: scaleSize(info.top - rectT),
            left: scaleSize(info.left - rectL),
            fill: '#fff',
            selectable: false,
            evented: false,
          })
        }
        if (info.QRCodeFormat == 'DMCode') {
          let canvas = document.createElement('canvas')
          try {
            BwipJs.toCanvas(canvas, {
              bcid: 'datamatrix', // Barcode type
              text: url, // Text to encode
              scale: 1, // 3x scaling factor
              width: scaleSize(mmToPx(info.mWidth, arrPI)),
              height: scaleSize(mmToPx(info.mHeight, arrPI)),
            })
            const uri = canvas.toDataURL('image/png')
            fabric.Image.fromURL(
              uri,
              (img) => {
                img.set({
                  top: !GEN_PART_COLOR_REVERT
                    ? scaleSize(info.top - rectT)
                    : scaleSize(info.top - rectT + 2.5),
                  left: !GEN_PART_COLOR_REVERT
                    ? scaleSize(info.left - rectL)
                    : scaleSize(info.left - rectL + 2.5),
                  selectable: false,
                })
                my_canvas.add(
                  !GEN_PART_COLOR_REVERT
                    ? img
                    : new fabric.Group([bgRect, img], {
                        top: scaleSize(info.top - rectT),
                        left: scaleSize(info.left - rectL),
                      })
                )
              },
              {
                scaleX: 0.35, // 缩放
                scaleY: 0.35, // 缩放
              }
            )
          } catch (e) {
            // `e` may be a string or Error object
            console.error(e)
          }
        } else {
          const qrSize = getQrCodeGenSize(info, arrPI)
          QRCode.toDataURL(url, {
            height: qrSize.height,
            width: qrSize.width,
            margin: 0,
            quality: 1,
            format: 'jpeg',
            mode: 'byte',
          }).then((url) => {
            fabric.Image.fromURL(url, (img) => {
              img.set({
                top: !GEN_PART_COLOR_REVERT
                  ? scaleSize(info.top - rectT)
                  : scaleSize(info.top - rectT + 2.5),
                left: !GEN_PART_COLOR_REVERT
                  ? scaleSize(info.left - rectL)
                  : scaleSize(info.left - rectL + 2.5),
                scaleX: qrSize.displayW / img.width,
                scaleY: qrSize.displayH / img.height,
                selectable: false,
              })
              my_canvas.add(
                !GEN_PART_COLOR_REVERT
                  ? img
                  : new fabric.Group([bgRect, img], {
                      top: scaleSize(info.top - rectT),
                      left: scaleSize(info.left - rectL),
                    })
              )
            })
          })
        }
        break
      }
      // 条形码
      case 'Onecode': {
        let OneCodeUrl = '',
          plankNumV = '',
          simplePlankNum = part.simplePlankNum
        const { front_file_identifier, opposite_file_identifier } =
          store.state.ncSetting
        if (info.source_data === 'plankNum') {
          if (frontH || sholesL || fSlots) {
            plankNumV = part.plankNum
            simplePlankNum += front_file_identifier ?? ''
            const flag = allHoleSlot.every((item) => item.side == -1)
            if (flag && allHoleSlot.length) {
              break
            }
          }
        } else if (info.source_data === 'plankNumF') {
          if (backH || bSlots || judgePtpNeedBackNum(sSlots, sholesL)) {
            simplePlankNum += opposite_file_identifier ?? ''
            plankNumV = currentPlank.oriPlankNumF
            const flag = allHoleSlot.every((item) => item.side == 1)
            if (
              flag &&
              !judgePtpNeedBackNum(sSlots, sholesL) &&
              allHoleSlot.length
            ) {
              break
            }
          }
        } else if (info.source_data === 'oriPlankNum') {
          if (info.showCode) {
            plankNumV = part.oriPlankNum
          } else {
            // 只有有孔槽才显示条码
            if (
              frontH ||
              backH ||
              sholesL ||
              (slots && slots.length) ||
              sSlots
            ) {
              if (info.switchCodeValueShunt) {
                const holeAndSlots = [...holes, ...slots]
                const flag =
                  (holeAndSlots.length &&
                    !(
                      holeAndSlots.every((i) => i.process_in_engraving) ||
                      holeAndSlots.every((i) => i.process_in_aio)
                    )) ||
                  sholesL ||
                  sSlots
                if (flag) {
                  plankNumV = part.oriPlankNum
                } else {
                  plankNumV = ''
                }
              } else {
                plankNumV = part.oriPlankNum
              }
            }
          }
        } else if (info.source_data === 'oriPlankNumNoMark') {
          if (info.showCode) {
            plankNumV = part.oriPlankNumNoMark
          } else {
            // 只有有孔槽才显示条码
            if (
              frontH ||
              backH ||
              sholesL ||
              (slots && slots.length) ||
              sSlots
            ) {
              plankNumV = part.oriPlankNumNoMark
            }
          }
        } else if (info.source_data === 'remarks') {
          plankNumV = part.remarks
        } else if (info.source_data === 'remark') {
          if (!!part.remark) {
            hasMoreThanAscii = [...part.remark].some(
              (char) => char.charCodeAt(0) > 127
            )
            let text = ''
            plankNumV = part.remark
            if (
              (hasMoreThanAscii || part[info.source_data].length > 50) &&
              false
            ) {
              plankNumV = ''
              text = '不支持该数据'
              let height = info.rectHeight ?? 11.3
              let width = info.rectWidth ?? 11.3
              let Itext = new fabric.Text(text, {
                fontSize: scaleSize(info.fontSize),
                selectable: false,
                fontWeight: info.fontWeight,
                left: scaleSize(info.left - rectL) + width / 2,
                top: scaleSize(info.top - rectT) + height / 2,
                fontFamily: getTagFontFamily(info.fontFamily) ?? '微软雅黑',
                fontSize: 18,
                rectWidth: width,
                rectHeight: height,
              })
              my_canvas.add(Itext)
            }
          }
        } else if (info.source_data === 'ncName') {
          plankNumV = info.isOnecodeNCSuffix
            ? part.ncName
            : part.ncName.substring(0, part.ncName.lastIndexOf('.'))
        } else break
        if (!plankNumV) break
        if (
          nc_setting.genSimpleLabelBarcode &&
          info.source_data !== 'ncName' &&
          info.source_data !== 'remark'
        )
          plankNumV = simplePlankNum
        let codeWidth = 0
        let OSvg = document.createElement('svg')
        let Ocanvas = document.createElement('canvas')
        // 标签数小于等于500时，使用svg
        try {
          JsBarcode(Ocanvas, plankNumV, getOnecodeJsBarcodeOptions(info, arrPI))
          OneCodeUrl = Ocanvas.toDataURL('image/png', 1)
          if (!OneCodeUrl) break
          // 开启小板标签反色时
          let bgRect
          if (GEN_PART_COLOR_REVERT) {
            // 创建白色背景矩形（尺寸比图像稍大 凭感觉调的）
            bgRect = new fabric.Rect({
              width: scaleSize(mmToPx(info.mWidth, arrPI)) + 15,
              height: scaleSize(mmToPx(info.mHeight, arrPI)) - 10,
              top: scaleSize(info.top - rectT),
              left: scaleSize(info.left - rectL),
              fill: '#fff',
              selectable: false,
              evented: false,
            })
          }
          fabric.Image.fromURL(OneCodeUrl, (img) => {
            img.set({
              top: !GEN_PART_COLOR_REVERT
                ? scaleSize(info.top - rectT)
                : scaleSize(info.top - rectT + 2.5),
              left: !GEN_PART_COLOR_REVERT
                ? scaleSize(info.left - rectL)
                : scaleSize(info.left - rectL + 2.5),
              ...getOnecodeImageScale(),
              selectable: false,
            })
            /** 重新绘制文字 */
            const textW = scaleSize(mmToPx(info.mWidth, arrPI)) / 4
            const textH = scaleSize(mmToPx(info.mHeight, arrPI)) * 0.85
            plankNumV += ''
            const scaleX = info.mWidth / 32.54
            const scaleY = info.mHeight / 9.52
            const textScale = scaleX < scaleY ? scaleX : scaleY
            let Bartext = new fabric.Text(plankNumV, {
              fontSize: scaleSize(info.fontSize) * textScale,
              selectable: false,
              fontWeight: info.fontWeight === 'bold' ? 'bold' : '',
              top: !GEN_PART_COLOR_REVERT
                ? scaleSize(info.top - rectT) + textH
                : scaleSize(info.top - rectT) + textH + 5,
              left: scaleSize(info.left - rectL),
              fontFamily: getTagFontFamily(info.fontFamily) ?? '微软雅黑',
              fill: TEXTCOLOR,
            })
            let oCGroup = !GEN_PART_COLOR_REVERT
              ? [img, Bartext]
              : [bgRect, img, Bartext]
            let OnecodeGroup = new fabric.Group(oCGroup, {
              top: scaleSize(info.top - rectT),
              left: scaleSize(info.left - rectL),
            })
            OnecodeGroup.rotate(info.rotateDeg)
            my_canvas.add(OnecodeGroup)
          })
        } catch (err) {
          OneCodeUrl = ''
          console.log('error', err)
        }
        // }

        break
      }
      // 板件图形
      case 'Typography':
        drawEditParts(
          template,
          plank,
          part,
          part_index,
          info,
          rectL,
          rectT,
          my_canvas,
          sort_value,
          isHasSixSideDrillPlankBase
        )
        break

      case 'wardrobeNum': {
        const { field, roomSortWay } = info
        const { roomName, loc } = part
        const textValue = getPartFlag(
          { field, roomSortWay, part },
          { roomName, loc },
          roomAndCabinetMap
        )
        if (textValue === '') break
        let radius = scaleSize(info.radius)
        const realRadius = info.realRadius
        let circle = new fabric.Circle({
          radius: radius, //圆形半径
          fill: !GEN_PART_COLOR_REVERT ? '#fff' : '#000', //填充的颜色
          stroke: !GEN_PART_COLOR_REVERT ? '#000' : '#fff', // 边框颜色
          strokeWidth: 1, // 边框大小
          visible: realRadius > 0,
        })
        let numText = new fabric.IText(String(textValue), {
          fontSize: scaleSize(info.fontSize),
          fontWeight: info.fontWeight,
          originX: 'cneter',
          originY: 'cneter',
          left: radius,
          top: radius,
          fontFamily: info.fontFamily ?? '微软雅黑',
          roomSortWay: info.roomSortWay,
          fill: TEXTCOLOR,
        })
        let cirGroup = new fabric.Group([circle, numText], {
          left: scaleSize(info.left - rectL),
          top: scaleSize(info.top - rectT),
        })
        my_canvas.add(cirGroup)
        break
      }
      // 小板标记
      case 'smallPlateMarking':
        const {
          fontFamily,
          fontPt,
          fontSize,
          height,
          width,
          left: l,
          top: t,
          fontWeight,
        } = info
        const { oRect } = part
        const max = Math.max(oRect.width, oRect.height)
        const min = Math.min(oRect.width, oRect.height)
        const { longSide, shortSide } = nc_setting?.smallPlankCondition || {}
        if (
          max >= longSide &&
          min >= shortSide &&
          nc_setting?.smallPlankCondition // 预览状态下，能显示小板标记
        )
          break
        // 画矩形
        const rectEl = new fabric.Rect({
          width: scaleSize(width),
          height: scaleSize(height),
          fill: '#fff',
          stroke: '#000',
          strokeWidth: 1,
          left: scaleSize(l),
          top: scaleSize(t),
          originX: 'center',
          originY: 'center',
        })
        // 画文字
        const textEl = new fabric.Text('小板', {
          fontSize: scaleSize(fontSize),
          fontPt: scaleSize(fontPt),
          left: scaleSize(l),
          top: scaleSize(t),
          originX: 'center',
          originY: 'center',
          fontFamily: getTagFontFamily(fontFamily),
          fontWeight: fontWeight ? 'bold' : '',
        })
        // group
        const group = new fabric.Group([rectEl, textEl], {
          left: scaleSize(info.left - rectL),
          top: scaleSize(info.top - rectT),
        })
        my_canvas.add(group)
        break

      case 'Table': {
        let tableData = []
        const { fontSize, top, left, source_data, fontFamily } = info
        if (
          info.source_data === 'extraParts' &&
          part.extraParts &&
          part.extraParts.length
        ) {
          tableData = part.extraParts.map((e) => [e.name, e.spec, e.num + ''])
        }
        fabricTable(
          my_canvas,
          false,
          tableData,
          scaleSize(fontSize),
          source_data,
          scaleSize(top - rectT),
          scaleSize(left - rectL),
          fontFamily,
          { gen_part_color_revert: GEN_PART_COLOR_REVERT }
        )
        break
      }

      case 'EdgeBand': {
        //  根据封边值绘制 通过加粗边表明是否封边 的矩形
        const {
          left,
          top,
          width,
          mWidth,
          height,
          mHeight,
          scaleX,
          scaleY,
          strokeWidth,
          stroke,
        } = info

        const rectLeft = scaleSize(left - rectL)
        const rectTop = scaleSize(top - rectT)

        const scale =
          Math.max(scaleX, scaleY) > 1 ? Math.max(scaleX, scaleY) : 1
        const rectWidth = width * scale * 2
        const rectHeight = height * scale * 2
        // const size = Math.max(rectWidth, rectHeight) * scale * 2 // 边框的尺寸 就取最大的值 确保为矩形
        const rectStrokeWidth = 8 // 没有宽度得设置 直接定死即可

        // 解析封边字符串，格式如 "←0.7↓0.7→1.8↑0.7"，有数字就代表该方向边需要封边，加粗该方的边框
        let leftWidth = rectStrokeWidth // 左边框宽度
        let downWidth = rectStrokeWidth // 下边框宽度
        let rightWidth = rectStrokeWidth // 右边框宽度
        let upWidth = rectStrokeWidth // 上边框宽度

        if (part.edgeInfo) {
          // const matches = part.edgeInfo.match(/←([\d.]+)↓([\d.]+)→([\d.]+)↑([\d.]+)/);
          // 兼容封边数据确实问题，默认为0
          const edgeInfoStr = part.edgeInfo
          let leftVal = 0,
            downVal = 0,
            rightVal = 0,
            upVal = 0
          // 分别匹配每个方向的封边信息
          const leftMatch = edgeInfoStr.match(/←([\d.]+)/)
          const downMatch = edgeInfoStr.match(/↓([\d.]+)/)
          const rightMatch = edgeInfoStr.match(/→([\d.]+)/)
          const upMatch = edgeInfoStr.match(/↑([\d.]+)/)

          // 如果匹配到则赋值，否则保持默认值0
          if (leftMatch) leftVal = Number(leftMatch[1])
          if (downMatch) downVal = Number(downMatch[1])
          if (rightMatch) rightVal = Number(rightMatch[1])
          if (upMatch) upVal = Number(upMatch[1])

          // 转为是否封边的布尔值
          const isLeft = parseFloat(leftVal) !== 0
          const isDown = parseFloat(downVal) !== 0
          const isRight = parseFloat(rightVal) !== 0
          const isUp = parseFloat(upVal) !== 0

          // 根据 rotateDeg 和 xyReverse 旋转方向（与 VisibleEdge 一致）
          const result = rotateDirections(
            isLeft,
            isDown,
            isRight,
            isUp,
            rotateDeg
          )

          leftWidth = result.isLeft ? rectStrokeWidth : 1
          downWidth = result.isDown ? rectStrokeWidth : 1
          rightWidth = result.isRight ? rectStrokeWidth : 1
          upWidth = result.isUp ? rectStrokeWidth : 1
        }

        // 创建四个边框矩形
        const edges = []

        // 上边框 (up)
        if (upWidth > 0) {
          edges.push(
            new fabric.Rect({
              left: rectLeft,
              top: rectTop,
              width: rectWidth,
              height: upWidth,
              fill: GEN_PART_COLOR_REVERT ? '#fff' : stroke,
              selectable: false,
              typeName: 'EdgeBand',
              originX: 'left',
              originY: 'top',
            })
          )
        }

        // 右边框 (right)
        if (rightWidth > 0) {
          edges.push(
            new fabric.Rect({
              left: rectLeft + rectWidth - rightWidth,
              top: rectTop,
              width: rightWidth,
              height: rectHeight,
              fill: GEN_PART_COLOR_REVERT ? '#fff' : stroke,
              selectable: false,
              typeName: 'EdgeBand',
              originX: 'left',
              originY: 'top',
            })
          )
        }

        // 下边框 (down)
        if (downWidth > 0) {
          edges.push(
            new fabric.Rect({
              left: rectLeft,
              top: rectTop + rectHeight - downWidth,
              width: rectWidth,
              height: downWidth,
              fill: GEN_PART_COLOR_REVERT ? '#fff' : stroke,
              selectable: false,
              typeName: 'EdgeBand',
              originX: 'left',
              originY: 'top',
            })
          )
        }

        // 左边框 (left)
        if (leftWidth > 0) {
          edges.push(
            new fabric.Rect({
              left: rectLeft,
              top: rectTop,
              width: leftWidth,
              height: rectHeight,
              fill: GEN_PART_COLOR_REVERT ? '#fff' : stroke,
              selectable: false,
              typeName: 'EdgeBand',
              originX: 'left',
              originY: 'top',
            })
          )
        }
        // 将所有边框添加到画布
        edges.forEach((edge) => {
          my_canvas.add(edge)
        })
        break
      }
      case 'VisibleEdge': {
        // 绘制见光边标识（数值非 0 的方向为见光边）
        if (part.lightEdgeInfo) {
          addEdgeIndicatorGroup({
            canvas: my_canvas,
            info,
            rectL,
            rectT,
            directions: parseLightEdgeDirections(part.lightEdgeInfo),
            rotateDeg,
            typeName: 'VisibleEdge',
          })
        }
        break
      }
      case 'FrontEdge': {
        // 绘制前封边标识（字符串含对应箭头即为该方向前封边）
        if (part.model_front_edge) {
          addEdgeIndicatorGroup({
            canvas: my_canvas,
            info,
            rectL,
            rectT,
            directions: parseArrowEdgeDirections(part.model_front_edge),
            rotateDeg,
            typeName: 'FrontEdge',
          })
        }
        break
      }
      // 五六面钻放板基准--箭头
      case 'sixSideDrillArrow': {
        // 在这里绘制五六面钻放板基准--箭头
        const { rotateNum } = part // 方向
        const { left, top, width, scaleX } = info

        // 位置基准调整：减去模板基准位置并应用缩放
        const adjustedLeft = scaleSize(left - rectL)
        const adjustedTop = scaleSize(top - rectT)
        const radius = scaleSize((width * scaleX) / 2)

        // 方向与角度映射，默认指向左边（-90）
        // rotateNum值为0，1，2，3分别对应左下，左上，右上，右下
        const angleArr = [-90, 0, 90, 180]
        const angle = angleArr[rotateNum] ?? -90
        // 创建白色圆形背景 - 使用相对位置
        const circle = new fabric.Circle({
          left: 0, // 相对于组的中心位置
          top: 0, // 相对于组的中心位置
          radius: radius,
          fill: '#ffffff',
          stroke: '#d3d3d3', // 浅灰色边框
          strokeWidth: 1,
          selectable: false,
          hasControls: false,
          originX: 'center',
          originY: 'center',
        })

        // 创建等腰三角形 - 底边长是半径的1.6，高是半径的0.8
        const arrow = new fabric.Triangle({
          width: radius * 1.6,
          height: radius * 0.8,
          left: 0,
          top: -radius * 0.4,
          originX: 'center',
          originY: 'center',
          fill: '#555555', // 深灰色
          stroke: 'transparent',
          selectable: false,
          hasControls: false,
          angle: 0,
        })

        // 创建矩形 - 使用相对位置
        const rect = new fabric.Rect({
          width: radius * 0.6,
          height: radius * 0.8,
          fill: '#555555',
          strokeWidth: 1,
          left: 0,
          top: radius * 0.4 - 1,
          originX: 'center',
          originY: 'center',
          selectable: false,
          hasControls: false,
        })

        // 将圆形和箭头组合成一个组
        const group = new fabric.Group([circle, arrow, rect], {
          left: adjustedLeft,
          top: adjustedTop,
          selectable: false,
          hasControls: false,
          typeName: 'sixSideDrillArrow',
        })
        // 应用旋转角度
        group.rotate(angle)
        my_canvas.add(group)
        break
      }
      // 五六面钻放板基准--三角角标
      case 'sixSideDrillTriangle': {
        const polygon = drawFiveSixDir(template, part, info)
        polygon.typeName = 'sixSideDrillTriangle'
        my_canvas.add(polygon)
        break
      }
    }
  })
  // 在不是大板标签的情况下去记录需要发送给彩标的数据，此代码不影响标签生成
  if (template.type !== 'plank') {
    transformToEzSort.generateExtraDatasources([], {
      part,
      plank,
      plank_index,
      total_part,
      template,
      label_num,
    })
  }
  // 如果开启了彩色标签设置
  if (PRINT_COLOR_TAG && !judgeLimit) {
    // 订单 40/60 15/40 是需求文档里面的颜色块比例
    const length = 1 //中间白条
    drawColorRect(
      0,
      0,
      scaleSize(mmToPx((40 / 60) * template.tag_width) - length),
      scaleSize(mmToPx((15 / 40) * template.tag_height) - length),
      part?.colorRes?.orderNo ?? 'rgb(255, 255, 255)',
      my_canvas
    )
    // 房间
    drawColorRect(
      scaleSize(mmToPx((15 / 40) * template.tag_height) + length),
      0,
      scaleSize(mmToPx((40 / 60) * template.tag_width) - length),
      scaleSize(mmToPx((25 / 40) * template.tag_height) - length),
      part?.colorRes?.roomName ?? 'rgb(255, 255, 255)',
      my_canvas
    )
    // 单元柜体
    drawColorRect(
      0,
      scaleSize(mmToPx((40 / 60) * template.tag_width) + length),
      scaleSize(mmToPx((20 / 60) * template.tag_width) - length),
      scaleSize(mmToPx((30 / 40) * template.tag_height) - length),
      part?.colorRes?.loc ?? 'rgb(255, 255, 255)',
      my_canvas
    )
    // 门板
    drawColorRect(
      scaleSize(mmToPx((30 / 40) * template.tag_height) + length),
      scaleSize(mmToPx((40 / 60) * template.tag_width) + length),
      scaleSize(mmToPx((20 / 60) * template.tag_width) - length),
      scaleSize(mmToPx((10 / 40) * template.tag_height) - length),
      part.type == 'Plank' ? 'rgb(255, 255, 255)' : '#DCDCDC',
      my_canvas
    )
  }
  transformToEzSort.addPage()
  return new Promise((resolve) => {
    const tagEncodingFormat = NC_SETTING.labelImageFormatNew
    const runAfterSideDiagram = () => {
      setTimeout(() => {
        my_canvas.renderAll()
        let base64
        setTimeout(async () => {
          // 特殊标记
          const opacity = store.state.drawOpacity
          const sizeAuto = store.state.drawSizeAuto
          const size = store.state.drawSize
          // 判断模板中是否有自定义特殊标签
          if (specialMarkParList.length <= 0) {
            drawSpecialSign(
              my_canvas,
              part.specialFlag,
              template,
              opacity,
              sizeAuto,
              size,
              { gen_part_color_revert: GEN_PART_COLOR_REVERT }
            )
          } else {
            specialMarkParList.forEach((param) => {
              const { my_canvas, sign, template, opacity, sizeAuto, size, op } =
                param
              drawSpecialSign(
                my_canvas,
                sign,
                template,
                opacity,
                sizeAuto,
                size,
                { gen_part_color_revert: GEN_PART_COLOR_REVERT },
                op
              )
            })
            specialMarkParList.length = 0
          }
          constrainTypographyToTag(my_canvas)
          if (collect) {
            base64 = my_canvas.toDataURL({
              quality: 1,
              multiplier: TAG_EXPORT_MULTIPLIER,
              format: tagEncodingFormat,
            })
            collect.push(await getTagImageByResolution(base64, NC_SETTING))
          }
          if (CONFIG.type === 'base64')
            resolve(
              base64 ||
                my_canvas.toDataURL({
                  quality: 1,
                  multiplier: TAG_EXPORT_MULTIPLIER,
                  format: tagEncodingFormat,
                })
            )
          else if (CONFIG.type === 'o_size_base64')
            resolve(
              my_canvas.toDataURL({
                quality: 1,
                format: tagEncodingFormat,
              })
            )
          else resolve(my_canvas.toSVG())
        }, 0)
      }, 0)
    }
    Promise.all(sideDiagramPromises)
      .then(runAfterSideDiagram)
      .catch(runAfterSideDiagram)
  })
}

/** 初始化 config **/
function initConfig(config) {
  if (!config.scale) config.scale = 1
  if (!config.backgroundColor) config.backgroundColor = '#fff'
  if (!config.type) config.type = 'svg'
  if (!config.canvas) config.canvas = 'tag'
  configScale = config.scale
  return config
}
function constrainTypographyToTag(canvas) {
  const typography = canvas
    .getObjects()
    .find(
      (object) =>
        object.typeName === 'Typography' && object.shouldConstrainToCanvas
    )
  if (!typography?.templateRegion) return

  alignTypographyToTemplateOrigin(typography, typography.templateRegion)
  const typographyBounds = typography.getBoundingRect()
  const { scale } = fitTypographyBounds(typographyBounds, {
    width: canvas.width,
    height: canvas.height,
  })
  if (scale < 1) {
    typography.scale(scale)
    const [diagram, ...edgeColorTexts] = typography.getObjects()
    const edgeTexts =
      diagram?.getObjects?.().filter((object) => object.canRotate) ?? []
    preserveTypographyTextScale([...edgeTexts, ...edgeColorTexts], scale)
    alignTypographyToTemplateOrigin(typography, typography.templateRegion)
  }
  constrainTypographyToCanvas(typography, canvas)
}

export function countSourceData(
  part,
  plank,
  plank_index,
  total_part,
  template,
  my_canvas,
  info,
  label_num,
  options = {
    genTagWay: 'export',
  }
) {
  if (!info.source_data) return ''
  let result = ''
  const isPreview = options.genTagWay === 'preview'
  let display =
    store.state.preferencesSetting.setting.roomCabinetPanelNameDisplay &&
    (store.state.userPermissions['room_cabinet_panel_name_display'] ||
      isPreview)
  // 构造新封边的展示 1(0.1) ←A↓B→C↑D（预铣括号仅 appliedSides 非 0 的边）
  let newEdgeInfo = appendPreMillingToEdgeInfoDisplay(
    part.edgeInfo,
    part.edgePreMillingInfo
  )
  switch (info.source_data) {
    case 'plank_index':
      result = plank.isDesMaterialNoCut ? '' : `第${plank_index}张大板`
      break
    case 'partsChildren':
      const hingeTypeList = ['铰链', '普通铰链', '一字底座铰链']
      if (part.partsChildren && part.partsChildren.length) {
        let isExist = hingeTypeList.includes(part.partsChildren[0].name)
        if (isExist) {
          let hingeString =
            part.partsChildren[0].matSpec +
            '_' +
            part.partsChildren[0].maskPartName
          result = hingeString
        }
      }
      break

    case 'lable_index':
      result = `第${label_num + 1}/${total_part}页`
      break
    case 'roomName':
      if (display && isDualLanguageTagUserSetTranslate('roomName')) {
        result = translateCustomTag(part[info.source_data], 'roomName')
      } else {
        result = part[info.source_data]
      }
      break
    case 'loc':
      if (display && isDualLanguageTagUserSetTranslate('loc')) {
        result = translateCustomTag(part[info.source_data], 'loc')
      } else {
        result = part[info.source_data]
      }
      break
    case 'partName':
      if (sessionStorage.getItem('material_cache_data')) {
        result = part[info.source_data]
      } else {
        if (part[info.source_data]) {
          const res = part[info.source_data].split('_')
          // 避免A_B_的情况进入判断 但是类似于A_B_undefined还是正常走截取逻辑吧
          if (res.length <= 2 || (res.length === 3 && res[2] === '')) {
            result = res.join('_')
          } else {
            result = res.slice(2).join('_')
          }
        }
      }
      if (display && isDualLanguageTagUserSetTranslate('partName')) {
        result = translateCustomTag(result, 'name')
      }
      break
    case 'address':
      result = part._isBujian
        ? part._bujianAddress ?? part[info.source_data] ?? ''
        : part[info.source_data] ?? ''
      break
    case 'orderNo':
      result = part._isBujian
        ? part._bujianOrderNo ?? part[info.source_data] ?? ''
        : part[info.source_data] ?? ''
      break
    case 'customer_name':
      result = part._isBujian
        ? part._bujianCustomerName ??
          part[info.source_data] ??
          part['customer'] ??
          ''
        : part[info.source_data] ?? part['customer'] ?? ''
      break
    case 'customer':
      result = part._isBujian
        ? part._bujianCustomerName ??
          part[info.source_data] ??
          part['customer'] ??
          ''
        : part['customer'] ?? ''
      break
    case 'plankID':
      result = part[info.source_data] ? `${part[info.source_data]}#` : ''
      break
    case 'onlyPlankID':
      result = part['plankID'] ? part['plankID'] : ''
      break
    case 'handleSlopes':
      let str = genHandleSlopesStr(part)
      result = part['handleSlopes'] ? str.replace('\n', '') : ''
      break
    case 'plank_remarks':
      result = part[info.source_data] ? `${part[info.source_data]}` : ''
      break
    case 'frontProcess': {
      const frontArr = [...part.holes, ...part.slots]
      const frontRes = frontArr.some((item) => item.side == 1)
      if (frontRes) {
        result = '加工正面'
      }
      break
    }
    case 'reverseProcess': {
      const reversArr = [...part.holes, ...part.slots]
      const reversRes = reversArr.some((item) => item.side == -1)
      if (reversRes) {
        result = '加工反面'
      }
      break
    }
    case 'sideProcess': {
      const sideRes = part.sholes.length || part.sslots.length
      if (sideRes) {
        result = '加工侧面'
      }
      break
    }
    case 'oSize':
      if (info.sizeRestrict) {
        result = dealSizeNum(part[info.source_data], info.sizeRestrictNum)
      } else {
        const str = part[info.source_data]
          .split('*')
          .map((s) => Number(s))
          .join('*')
        result = str || ''
      }
      break
    case 'oSize_L':
      result = part.oSize
        .split('*')
        .slice(0, 2)
        .map((s) => Number(s))
        .join('*')
      break
    case 'oSize_W_L_T':
      const tempList = part.oSize.split('*').map((size) => Number(size))
      result = `${tempList[1]}*${tempList[0]}*${tempList[2]}`
      break
    case 'cutSize':
      if (info.sizeRestrict) {
        result = dealSizeNum(part[info.source_data], info.sizeRestrictNum)
      } else {
        result = part[info.source_data]
      }
      break
    case 'doorSize':
      result = dealSizeNum(part[info.source_data])
      break
    case 'size':
      result = dealSizeNum(part[info.source_data])
      break
    case 'loc_size':
      const locSize = part[info.source_data]
      if (locSize) {
        result = `${Number(locSize.width * 1000).toFixed(2)}*${Number(
          locSize.height * 1000
        ).toFixed(2)}*${Number(locSize.depth * 1000).toFixed(2)}`
      } else {
        result = ''
      }
      break
    case 'bigPlankID':
      result = plank_index + ''
      break
    case 'oriPlankNum':
      result = store.state.ncSetting.genSimpleLabelBarcode
        ? part.simplePlankNum
        : part[info.source_data]
      break
    case 'paibanTime':
      result = getPaibanTime()
      break
    case 'plankSignBox': {
      const sign = template.tem_data.find(
        (item) =>
          item.data.source_data == 'plankSign' &&
          item.data.item_id == info.item_id
      )
      if (!sign) break
      const { fontPt, fontSize, fontWeight, lineHeight, top, left } = sign.data
      let t = new fabric.Text(sign.data.text, {
        fontPt,
        fontSize: scaleSize(fontSize),
        fontWeight,
        lineHeight,
      })
      if (my_canvas) {
        drawSignRect(
          {
            top,
            left,
            width: t.width,
            height: t.height,
            rectL: template.rectInfo.left,
            rectT: template.rectInfo.top,
          },
          my_canvas
        )
      }
      break
    }

    case 'plankSign':
      result = '板件标注'
      break
    case 'sholeInfoF':
    case 'sslotInfoF': {
      const sourceData = info.source_data
      result =
        part[sourceData] && part[sourceData].length !== 2
          ? part[sourceData]
          : ''
      break
    }
    case 'process_label':
      // eslint-disable-next-line no-case-declarations
      const processMarkArr = []

      const remarksOptions = store.state.specialRemarks?.remarksOptions ?? {}
      const customizeOptions = store.state.specialRemarks?.customizeOptions

      if (customizeOptions) {
        const objArr = Object.values(customizeOptions)
        for (let idx = 0; idx < objArr.length; idx++) {
          const obj = objArr[idx]
          Object.assign(remarksOptions, obj)
        }
      }

      if (
        !remarksOptions ||
        Object.values(remarksOptions).every((item) => item)
      ) {
        part[info.source_data]?.auto_label?.forEach((item) => {
          processMarkArr.push(Object.values(item)[0])
        })
      } else {
        part[info.source_data]?.auto_label?.forEach((item) => {
          if (remarksOptions[Object.keys(item)[0]]) {
            processMarkArr.push(Object.values(item)[0])
          }
        })
      }
      part[info.source_data]?.custom_label?.forEach((item) => {
        processMarkArr.push(item)
      })
      result = processMarkArr.join('/')
      break
    case 'typesetting_batch':
      // 在这里绘制排版批次
      result = store.state.typesettingBatch || info.text
      break
    case 'hsInfoTotal':
      result = part.hsInfo || '0孔0槽'
      break
    // 铰链孔位置
    case 'hingeHoleLocationData':
      if (part.holes.length !== 0) {
        let xList = []
        let yList = []
        let arr = []
        for (let item of part.holes) {
          // 判断为铰链孔
          if (item.symbol == 'HINGE') {
            // 判断当前孔的x，y的距离
            xList.push(Number(item.ocenter.x.toFixed(2))) //距y轴的距离
            yList.push(Number(item.ocenter.y.toFixed(2))) //距x轴的距离
          }
        }
        if (!xList.length && !yList.length) {
          result = ''
          break
        }
        // 判断当前铰链孔在与y轴平行的线上还是与x轴平行的线上
        let direction
        if (xList.length === 1 && yList.length === 1) {
          let jz = xList[0]
          let jy = part.oRect.width - xList[0]
          let js = part.oRect.height - yList[0]
          let jx = yList[0]
          let minSort = [jz, jy, js, jx].sort((a, b) => {
            return a - b
          })[0]
          if (minSort === jz || minSort === jy) {
            arr = yList
            direction = 'vertical'
          } else {
            arr = xList
            direction = 'transverse'
            arr = arr.map((item) => {
              return part.oRect.width - item
            })
          }
        } else {
          if (
            xList.length === [...new Set(xList)].length &&
            yList.length !== [...new Set(yList)].length
          ) {
            // 铰链孔在与x轴平行的线上
            arr = xList
            direction = 'transverse'
            arr = arr.map((item) => {
              return part.oRect.width - item
            })
          } else {
            // 铰链孔在与y轴平行的线上
            arr = yList
            direction = 'vertical'
          }
        }
        let closeEdge
        let firstEdge
        // 判断距边的上下左右
        if (direction === 'transverse') {
          if (part.oRect.height - yList[0] > yList[0]) {
            closeEdge = '距上' + yList[0].toFixed(2)
          } else {
            closeEdge = '距下' + (part.oRect.height - yList[0]).toFixed(2)
          }
          firstEdge = '距右'
        } else {
          if (part.oRect.width - xList[0] > xList[0]) {
            closeEdge = '距左' + xList[0].toFixed(2)
          } else {
            closeEdge = '距右' + (part.oRect.width - xList[0]).toFixed(2)
          }
          firstEdge = '距上'
        }
        arr = arr.sort((a, b) => {
          return a - b
        })
        arr = arr.map((item) => {
          return item.toFixed(2)
        })
        result = firstEdge + arr.join(' ') + ' ' + closeEdge
      } else {
        result = ''
      }
      break
    // 料单铰链位置
    case 'hingeInfo':
      // 对hingeInfo的数据四舍五入保留两位 双开距上，竖双距右
      // 可以通过openDir进行判断当前的开门方向
      if (!part.openDir) {
        result = part?.hingeInfo?.map((item) => item.toFixed(2)).join(' ') || ''
        break
      }
      result =
        (['左开', '右开'].includes(part.openDir) ? '距下' : '距左') +
          part?.hingeInfo?.map((item) => item.toFixed(2)).join(' ') || ''
      break
    case 'hingeData':
      result = part?.hing_hole_info || ''
      break
    case 'edgeInfomation':
      result = newEdgeInfo || ''
      break
    // 封边值（描述封边长短）
    case 'edgeInfomationLength':
      result = getEdgeTypeWithRect(part?.edgeInfo, part?.rect)
      break
    case 'texDir':
      result = texDirMap[part[info.source_data]]
      break
    case 'connection_types': // 大板连接方式
      let arr = []
      part[info.source_data] &&
        Object.values(part[info.source_data]).forEach((item) => {
          if (item && !arr.includes(item)) arr.push(item)
        })
      result = arr.join('、')
      break
    case 'sameSizeBoardCount':
      // 首先判断当前的标签是否符合展示要求，不符合返回''
      // 这里的标签都是小板标签 所以只需要排除轮廓不是矩形的异形板就可以了
      let flag = false
      if (part.path) {
        let path = cloneDeep(part.path[0])
        path.splice(-1)
        if (!judgeRectangle(path)) {
          flag = true
        }
      }
      if (flag) {
        result = ''
      } else {
        const statisticsCount = template.statisticsCount ?? {}
        const oRect = part.oRect
        let statisticsSize = ''
        if (oRect.height > oRect.width) {
          statisticsSize = `${oRect.height}*${oRect.width}`
        } else {
          statisticsSize = `${oRect.width}*${oRect.height}`
        }
        const statisticsDimension = info.statisticsDimension ?? 'noLimit'
        let count = 0
        try {
          if (statisticsDimension == 'noLimit') {
            count = statisticsCount[statisticsSize]?.['noLimit'] || 0
          } else {
            if (statisticsDimension == 'sameRoom') {
              count =
                statisticsCount[statisticsSize]?.['sameRoom'][
                  `${part.orderNo ?? ''}-${part.roomName ?? ''}`
                ] || 0
            } else if (statisticsDimension == 'sameOrder') {
              count =
                statisticsCount[statisticsSize]['sameOrder'][part.orderNo ?? '']
            } else if (statisticsDimension == 'sameWardrobe') {
              count =
                statisticsCount[statisticsSize]?.['sameWardrobe'][
                  `${part.orderNo ?? ''}-${part.roomName ?? ''}-${
                    part.loc ?? ''
                  }`
                ] || 0
            }
          }
          result = `同尺寸小板${count}个`
        } catch (error) {
          result = ''
          console.error('error：' + error)
        }
      }
      break
    case 'matCode_not_high':
      result = getPlankMatCodeByNotHigh(part)
      break
    case 'plankSize':
      const sizeStr =
        plank[info.source_data] ??
        `${plank.plankWidth}*${plank.plankHeight}*${plank.thick}`
      const textArr = sizeStr.split('*')
      result = `${textArr[1]}*${textArr[0]}*${textArr[2]}`
      break
    case 'matCode':
      result =
        dealHighlightMatCode(part['_oriMatCode'] || part[info.source_data]) ||
        ''
      break
    // 彩标数据--特殊标记
    case 'specialMark':
      const specialMarkCN = {
        default: '',
        triangle_shape: '三角形',
        circle_shape: '圆形',
        square_shape: '方形',
        half_circle_shape: '半圆',
        hexagon_shape: '六边形',
      }
      result = specialMarkCN[part.specialFlag] || ''
      break
    // 彩标数据--面板标记
    case 'isFrontPlank':
      result = part.isFrontPlank ? '面板' : '非面板'
      break
    case 'texture':
      result =
        part['_oriTexture'] || part['oriTexture'] || part[info.source_data]
      break
    case 'handleModel':
      const handle = part['handle']
      if (handle) {
        result =
          handle.partsChildren?.find((item) => item.handleModelName)
            ?.handleModelName || ''
      }
      break
    case 'holeSlotIrregularData':
      const { holes, slots, curveHoles = [], sholes = [], sslots = [] } = part
      result = `${holes.length + sholes.length}孔${
        slots.length + sslots.length
      }槽${curveHoles.length}异形`
      break
    case 'sideHoleMachineProcessing':
    case 'sideHoleMachineProcessingF':
      const { xyReverse } = store.state.ncSetting
      const isFlip = info.source_data === 'sideHoleMachineProcessingF'
      const targets = getOtherSideMachineTargets(part, isFlip)
      result = genCCWSideHoleSlot(targets, xyReverse)
      break
    case 'longPlateProcessing':
      if (isLongPlateProcessing(part, store.state.ncSetting)) {
        result = translateLang('归方')
      } else {
        result = ''
      }
      break
    case 'plankTexAlignName': {
      result = part.textureGrainInfo?.groupName || ''
      break
    }
    default:
      result = part[info.source_data] || ''
      break
  }

  return String(result)
}

// 判断异形板
function isShape(part) {
  return Boolean(
    part?.specialShape || (Array.isArray(part?.path) && part.path.length > 0)
  )
}

/**
 * @description 判断是否是长板二次加工
 * @param part 小板信息
 */
export function isLongPlateProcessing(part, ncSetting) {
  if (!ncSetting.longPlankCuttingSetting) return false
  const {
    longPlankCuttingEnable,
    secondary_cutting_board_list,
    longPlankMinLength: longSide,
    longPlankShortMinLength: shortSide,
    cutSingleDoor,
    curveSecondCutEnable,
    cutGeneralPlank,
    generalPlankThick,
    single_door_thick,
    specified_board_secondary_cutting,
    desMaterialList,
    desMaterialSwitch,
    force_board_name,
  } = ncSetting.longPlankCuttingSetting

  if (!longPlankCuttingEnable) return false
  const rectWH = [part.realRect.width, part.realRect.height]
  const partLongSide = Math.max(...Object.values(rectWH))
  const partShortSide = Math.min(...Object.values(rectWH))
  // 切割条件：尺寸
  const isReachCuttingSize =
    partLongSide > longSide && partShortSide > shortSide
  // 切割条件：异形板二次切割
  const isCurveSecondaryCutting = isShape(part) ? curveSecondCutEnable : true
  // 切割条件：指定材质（与原先一致：仅当 length > 0 时才要求为数组且 matCode 命中列表；否则视为不限制）
  const isMatchDesMaterial = (() => {
    if (!desMaterialSwitch) return true
    const list = desMaterialList
    if (!list || !(list.length > 0)) return true
    const temp_matCode = String(part.matCode || '').replace(/高光_/g, '')
    return list.some((item) => temp_matCode === item)
  })()

  // 门板厚度阈值
  const singleDoorThickNum = Number(single_door_thick)
  // 常规板厚度阈值
  const generalPlankThickNum = Number(generalPlankThick)
  // 切割对象：门板厚度满足门板阈值
  const meetsSingleDoorThickness =
    cutSingleDoor && part.thick >= singleDoorThickNum
  // 切割对象：常规板厚度满足常规板阈值
  const meetsGeneralPlankThickness =
    cutGeneralPlank && part.thick >= generalPlankThickNum
  // 板件名称
  const partName = part.partName || part.name || ''
  // 切割对象：指定板名（开启时：忽略尺寸/其他筛选条件）
  const isForceBoardName =
    specified_board_secondary_cutting &&
    force_board_name &&
    secondary_cutting_board_list.some((item) => partName.includes(item))
  // 切割对象：指定板名
  const isSpecifiedBoardSecondaryCutting =
    specified_board_secondary_cutting &&
    secondary_cutting_board_list.some((item) => partName.includes(item))

  if (
    (meetsSingleDoorThickness && part.type === 'SingleDoor') ||
    (meetsGeneralPlankThickness && part.type !== 'SingleDoor') ||
    isSpecifiedBoardSecondaryCutting
  ) {
    // 忽略尺寸/其他筛选条件，强制启用
    if (isForceBoardName) return true
    // 满足任一条件后，再判断是否满足切割条件
    if (isReachCuttingSize && isCurveSecondaryCutting && isMatchDesMaterial) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

// 纹理映射
const texDirMap = {
  notcare: '无纹理',
  normal: '竖纹',
  reverse: '横纹',
}

function drawEditParts(
  template,
  plank,
  part,
  part_index,
  info,
  rectL,
  rectT,
  canvas,
  sort_value,
  isHasSixSideDrillPlankBase
) {
  // 指定材质不下料的小板不绘制 排版图
  if (part.isDesMaterialNoCut) return
  if (!info.mWidth || !info.mHeight) {
    return
  }
  // 小板获取当前板件的封边信息
  let edgeInfo = countEdgeInfoByJXType(part)
  let edgeTextureMap = { ...part.edge_texture_map }

  let scaleTemp = 1
  // 如果是余料板，则缩放比例为0.8
  if (part.specialType === 'supplus') {
    scaleTemp = 0.8
  }

  /** 大板的绘制轮廓 */
  const bigPlankDrawOutlinePath = getBigPlankDrawOutlinePath(plank, {
    JX_CHECKED,
    xyReverse: NC_SETTING.xyReverse,
  })

  // 如果是大板标签，则将内部的值替换成大板四周的边长信息，且后续计算更具此信息处理
  if (template.type === 'plank') {
    if (isLShapeSurplusBigPlank(plank)) {
      edgeInfo = getLShapeOutlineInfo(bigPlankDrawOutlinePath)
    } else if (isSpecialShapeSurplusBigPlank(plank)) {
      edgeInfo = getPlankOutlineInfo(bigPlankDrawOutlinePath)
    } else {
      edgeInfo = getPlankOutlineInfo(
        bigPlankDrawOutlinePath,
        NC_SETTING.xyReverse
      )
    }
  }
  new Promise((resolve) => {
    // 获取文本宽高
    let widthS = [],
      heightS = []
    info.textItems?.forEach((item) => {
      const str = getEdgeValue(item.positionName, edgeInfo)
      if (!str) return
      let text = new fabric.Text(str, {
        positionName: item.positionName,
        fontSize: scaleSize(item.fontSize),
        fontWeight: item.fontWeight,
      })
      widthS.push(text.width)
      heightS.push(text.height)
    })
    resolve({
      width: Math.max.apply(null, widthS),
      height: Math.max.apply(null, heightS),
      widthS,
    })
  }).then((data) => {
    // 如果设置了自定义放板基准，则绘制五六面钻放板基准
    if (!isHasSixSideDrillPlankBase) {
      if (FIVE_SIX_DIR) {
        if (typeof sixCb === 'function') {
          const polygon = drawFiveSixDir(template, part, info)
          sixCb(polygon)
        } else {
          const polygon = drawFiveSixDir(template, part, info)
          canvas.add(polygon)
        }
      }
    }

    // 限制边缘文字预留空间，避免长文本持续挤压排版图。
    const textHeight = Math.min(data.height, 18.08)
    const textWidth = Math.min(data.width, 30)

    let gW = mmToPx(info.mWidth, getDeviceXDPI())
    let gH = mmToPx(info.mHeight, getDeviceXDPI())

    // 减去字体的宽高，得到排版图的缩放比例
    let ScaleX =
      (gW - textWidth) /
      (NC_SETTING.xyReverse ? plank.plankHeight : plank.plankWidth)
    let ScaleY =
      (gH - textHeight) /
      (NC_SETTING.xyReverse ? plank.plankWidth : plank.plankHeight)
    let PlankScale = Math.min.apply(null, [ScaleX, ScaleY]) * scaleTemp // 按比例取出小一点的，按照缩放比例绘制排版图
    let plankW = plank.plankWidth * PlankScale
    let plankH = plank.plankHeight * PlankScale
    let paths = bigPlankDrawOutlinePath.map((v) => ({
      x: mmToPx(pxTomm(v.x * CONFIG.scale * PlankScale, DPI), DPI),
      y: mmToPx(pxTomm(v.y * CONFIG.scale * PlankScale, DPI), DPI),
    }))

    if (
      plank.surplusInfo &&
      ['lshape', 'specialShape'].includes(plank.surplusInfo.shape)
    ) {
      // 启用雕刻机翻面加工贴标模式 并且不是单面板 并且满足应急码才走此逻辑
      if (
        NC_SETTING.labelOverturn &&
        NC_SETTING?.emergence_setting_key?.includes('TURNBLANK') &&
        plank.ableToggle
      ) {
        paths = rollLShapePlank(paths, NC_SETTING.xyReverse)
      }
    }
    let rect = new fabric.Polygon(paths, {
      top: textHeight,
      left: textWidth,
      selectable: false,
      stroke: !GEN_PART_COLOR_REVERT ? '#000' : '#fff',
      strokeWidth: 1.5,
      fill: !GEN_PART_COLOR_REVERT ? '#fff' : '#000',
    })
    let parts_arr = []
    // 重新排序 先画异形板件
    let poyArr = [],
      rectArr = []
    plank.parts.forEach((item) => {
      if (item.path) {
        poyArr.push(item)
      } else {
        rectArr.push(item)
      }
    })
    let newPlankArr
    if (sort_value == 1) {
      newPlankArr = [...poyArr, ...rectArr]
    } else {
      newPlankArr = plank.parts
    }
    newPlankArr.forEach((item, index) => {
      // 转换数据（修改小板上的数据）
      item = transformData(item, store)
      // 异型
      if (item.path) {
        let curveHoles = []
        if (item.curveHoles) {
          curveHoles = item.curveHoles
            .filter((it) => it.deep >= item.thick)
            .map((it) => it.path)
        }
        let millInfo = []
        if (item.millInfo) {
          millInfo = item.millInfo
            .filter((it) => it.depth >= item.thick)
            .map((it) => it.shape)
        }
        const resPath = [...item.path, ...curveHoles, ...millInfo]
        resPath.forEach((pathItem, i) => {
          if (i === 0) {
            let pointArr = pathItem.map((item) => {
              return {
                x: scaleSize(item.x * PlankScale) + textWidth,
                y: scaleSize(item.y * PlankScale) + textHeight,
              }
            })
            let top = scaleSize(item.startY * PlankScale) + textHeight
            let left = scaleSize(item.startX * PlankScale) + textWidth
            let difShape = new fabric.Polygon(pointArr, {
              top: top,
              left: left,
              stroke: !GEN_PART_COLOR_REVERT ? '#000' : '#fff',
              strokeWidth: scaleSize(0.7),
              selectable: false,
              // fill: '#fff',
              fill: !GEN_PART_COLOR_REVERT ? 'transparent' : '#000',
            })
            if (template.type !== 'plank') {
              if (sort_value == 1) {
                if (item.priority - 1 === part_index)
                  difShape.set({
                    fill: !GEN_PART_COLOR_REVERT ? '#000' : '#fff',
                  })
              } else {
                if (index === part_index)
                  difShape.set({
                    fill: !GEN_PART_COLOR_REVERT ? '#000' : '#fff',
                  })
              }
            }
            parts_arr.push(difShape)
            // canvas.add(difShape);
          } else {
            let xs = [],
              ys = []
            let pointArr = pathItem.map((e) => {
              xs.push(e.x)
              ys.push(e.y)
              return {
                x: scaleSize(e.x * PlankScale) + textWidth,
                y: scaleSize(e.y * PlankScale) + textHeight,
              }
            })
            let top =
              Math.min.apply(null, ys) * PlankScale +
              (newPlankArr[index].startY * PlankScale +
                textHeight / CONFIG.scale)
            let left =
              Math.min.apply(null, xs) * PlankScale +
              (newPlankArr[index].startX * PlankScale +
                textWidth / CONFIG.scale)
            let difShape = new fabric.Polygon(pointArr, {
              top: scaleSize(top),
              left: scaleSize(left),
              stroke: !GEN_PART_COLOR_REVERT ? '#000' : '#fff',
              strokeWidth: scaleSize(0.7),
              selectable: false,
              // fill: '#fff',
              fill: !GEN_PART_COLOR_REVERT ? 'transparent' : '#000',
            })
            parts_arr.push(difShape)

            // canvas.add(difShape);
          }
        })
      } else {
        // 普通
        let itemRect = new fabric.Rect({
          width: scaleSize(item.rect.width * PlankScale),
          height: scaleSize(item.rect.height * PlankScale),
          top: scaleSize(item.startY * PlankScale) + textHeight,
          left: scaleSize(item.startX * PlankScale) + textWidth,
          stroke: !GEN_PART_COLOR_REVERT ? '#000' : '#fff',
          strokeWidth: scaleSize(0.7),
          fill: !GEN_PART_COLOR_REVERT ? '#fff' : '#000',
          // fill: 'transparent',

          selectable: false,
        })
        if (template.type !== 'plank') {
          if (sort_value == 1) {
            if (item.priority - 1 === part_index)
              itemRect.set({ fill: !GEN_PART_COLOR_REVERT ? '#000' : '#fff' })
          } else {
            if (index === part_index)
              itemRect.set({ fill: !GEN_PART_COLOR_REVERT ? '#000' : '#fff' })
          }
        }

        parts_arr.push(itemRect)
      }
    })
    let text_items = []
    let triangles = []

    // 旋转0度
    let deviationW = scaleSize(plankW) + textWidth * 2
    let deviationH = scaleSize(plankH) + textHeight * 2
    info.textItems?.forEach((item) => {
      let finalText = getEdgeValue(item.positionName, edgeInfo)
      if (!finalText) return
      let text = new fabric.Text(finalText, {
        positionName: item.positionName,
        fontSize: Math.max(16, scaleSize(item.fontSize)),
        fontWeight: item.fontWeight,
        fontFamily: item.fontFamily ?? '微软雅黑',
        fill: TEXTCOLOR,
      })
      // 物理左右边文字占用排版图的水平预留区；旋转后逻辑上下边会落到这里。
      if (
        isPhysicalLeftOrRightEdge(item.positionName, {
          rotateDeg: info.rotateDeg,
          xyReverse: NC_SETTING.xyReverse,
          rotatePlank: isRotatePlank,
        })
      ) {
        fitEdgeTextToWidth(text, textWidth)
      }
      switch (item.positionName) {
        case 'BE':
          text.set({
            top: deviationH - textHeight,
            left: deviationW / 2 - textWidth / 2,
          })
          break
        case 'TE':
          text.set({
            top: item.top,
            left: deviationW / 2 - textWidth / 2,
          })

          break
        case 'RE':
          text.set({
            top: deviationH / 2 - textWidth / 2,
            left: deviationW - textWidth,
          })

          break
        case 'LE':
          text.set({
            top: deviationH / 2 - textWidth / 2,
            left: item.left,
          })

          break
      }
      text.set({
        position: item.positionName,
        opacity:
          (info.showEdgeOff && +finalText <= 0) || info.showEdgeDisplay ? 0 : 1,
        canRotate: true,
      })
      text_items.push(text)
    })
    let groupTop = scaleSize(info.top - rectT)
    let groupLeft = scaleSize(info.left - rectL)

    if (NC_SETTING.xyReverse) {
      groupTop = scaleSize(info.top - rectT + (plankW - plankH) / 2)
      groupLeft = scaleSize(info.left - rectL - (plankW - plankH) / 2)
    }
    // 添加了前封边三角，保证排版图位置不变 需要扩大排版截图的范围
    // let offset = 10
    let offset = 0
    // 绘制开门方向
    const openDoor = drawOpenDoor(
      text_items,
      part,
      info,
      NC_SETTING,
      template.type,
      { gen_part_color_revert: GEN_PART_COLOR_REVERT }
    )
    let signs = []
    let showVisibleEdge = info.showVisibleEdge ?? true
    if (showVisibleEdge) {
      signs = drawLightSign(text_items, part, NC_SETTING, template.type, {
        gen_part_color_revert: GEN_PART_COLOR_REVERT,
      })
    }
    let formerEdge
    let showFrontEdge = info.showFrontEdge ?? true
    if (showFrontEdge) {
      formerEdge = drawFormerEdge(
        text_items,
        part,
        NC_SETTING,
        template.type,
        configScale ?? 1,
        JX_CHECKED,
        plank.surplusInfo &&
          ['lshape', 'specialShape'].includes(plank.surplusInfo.shape)
          ? TRIM_SIDE
          : '',
        { gen_part_color_revert: GEN_PART_COLOR_REVERT }
      )
    }

    const elements = [
      rect,
      ...triangles,
      ...parts_arr,
      ...text_items,
      ...signs,
      ...openDoor.arr,
      formerEdge,
    ].filter((it) => it)

    let Group = new fabric.Group(elements, {
      left: groupLeft + openDoor.distance - offset / 2,
      top: groupTop - offset / 2,
    })
    //处理旋转
    rotateKlass(Group, info)
    const edgeInfoColorTexts = []
    if (info.isShowDiffEdgeColor && part.edge_texture_map) {
      let edgeToPositionMap = null
      // 如果开启标签镜像
      if (JX_CHECKED) {
        const leftTexture = edgeTextureMap[1]
        const bottomTexture = edgeTextureMap[2]
        const rightTexture = edgeTextureMap[3]
        const topTexture = edgeTextureMap[4]
        // 镜像兼容xy互换的情况
        if (NC_SETTING.xyReverse) {
          edgeTextureMap[1] = leftTexture
          edgeTextureMap[2] = topTexture
          edgeTextureMap[3] = rightTexture
          edgeTextureMap[4] = bottomTexture
        } else {
          edgeTextureMap[1] = rightTexture
          edgeTextureMap[2] = bottomTexture
          edgeTextureMap[3] = leftTexture
          edgeTextureMap[4] = topTexture
        }
      }
      // 边缘纹理映射配置
      const edgeTextureMappings = {
        // 基础映射（0度）
        0: [1, 2, 3, 4],
        // 90度旋转
        90: [2, 3, 4, 1],
        // 180度旋转
        180: [3, 4, 1, 2],
        // 270度旋转
        270: [4, 1, 2, 3],
      }
      // XY互换时的映射调整
      const xyReverseMappings = {
        0: [4, 1, 2, 3],
        90: [1, 2, 3, 4],
        180: [2, 3, 4, 1],
        270: [3, 4, 1, 2],
      }
      const infoRotateDeg = info.rotateDeg || 0
      // 获取当前旋转角度对应的映射
      const currentMapping = NC_SETTING.xyReverse
        ? xyReverseMappings[infoRotateDeg]
        : edgeTextureMappings[infoRotateDeg]

      // 应用映射
      edgeToPositionMap = {
        LE: edgeTextureMap[currentMapping[0]],
        BE: edgeTextureMap[currentMapping[1]],
        RE: edgeTextureMap[currentMapping[2]],
        TE: edgeTextureMap[currentMapping[3]],
      }

      // 色卡信息文字
      info.textItems?.forEach((item) => {
        const edgeColor = edgeToPositionMap[item.positionName] ?? ''
        const isSameAsPlank =
          info.hideSameEdgeColorAsPlank && edgeColor === part.texture
        if (edgeColor && info.isShowDiffEdgeColor && !isSameAsPlank) {
          let edgeInfoColorTextItems = []
          // 将字符串拆分成字符数组
          const characters = ['(', ...edgeColor.split(''), ')']
          characters.forEach((char, index) => {
            // 判断字符是否为字母或数字
            const isAlphanumeric = /[a-zA-Z0-9(]/.test(char)
            let charTextItem = new fabric.Text(char, {
              fontSize: Math.max(16, scaleSize(item.fontSize)),
              fontWeight: item.fontWeight,
              fontFamily: item.fontFamily ?? '微软雅黑',
              fill: TEXTCOLOR,
              top: ['LE', 'RE'].includes(item.positionName)
                ? char === '(' && index === 0
                  ? 0
                  : index * scaleSize(item.fontSize) * 0.9
                : 0, // 垂直排列，0.8是行间距
              left: ['LE', 'RE'].includes(item.positionName)
                ? 0 // 垂直排列时，所有字符的left都相同
                : char === '(' && index === 0
                ? 0
                : index * scaleSize(item.fontSize) * 0.9, // 水平排列时，从左至右依次排列
              textAlign: 'center',
              originX: 'center',
              originY: 'center',
              angle: 0,
            })
            charTextItem.set({
              // 如果是LE和RE并且是()，则旋转90度
              angle:
                ['LE', 'RE'].includes(item.positionName) &&
                ['(', ')'].includes(char)
                  ? 90
                  : 0, // 旋转90度
            })
            edgeInfoColorTextItems.push(charTextItem)
          })
          const edgeInfoColorText = new fabric.Group(edgeInfoColorTextItems, {
            positionName: item.positionName,
            type: 'edgeColorInfo',
          })
          edgeInfoColorTexts.push(edgeInfoColorText)
        }
      })

      // 计算实际旋转角度（考虑XY互换）
      const rotateDeg = NC_SETTING.xyReverse
        ? infoRotateDeg
          ? infoRotateDeg - 90
          : 270
        : infoRotateDeg
      // 根据旋转角度计算真实位置和尺寸
      let realLeft, realTop, realWidth, realHeight
      switch (rotateDeg) {
        case 90:
          realLeft = Group.left - Group.height
          realTop = Group.top
          realWidth = Group.height
          realHeight = Group.width
          break
        case 180:
          realLeft = Group.left - Group.width
          realTop = Group.top - Group.height
          realWidth = Group.width
          realHeight = Group.height
          break
        case 270:
          realLeft = Group.left
          realTop = Group.top - Group.width
          realWidth = Group.height
          realHeight = Group.width
          break
        default: // 0度
          realLeft = Group.left
          realTop = Group.top
          realWidth = Group.width
          realHeight = Group.height
      }
      edgeInfoColorTexts.forEach((item) => {
        switch (item.positionName) {
          case 'LE':
            item.set({
              top: realTop + realHeight / 2 - item.getScaledHeight() / 2,
              left: realLeft - item.getScaledWidth(),
            })
            break
          case 'BE':
            item.set({
              top: realTop + realHeight,
              left: realLeft + realWidth / 2 - item.getScaledWidth() / 2,
            })
            break
          case 'RE':
            item.set({
              top: realTop + realHeight / 2 - item.getScaledHeight() / 2,
              left: realLeft + realWidth,
            })
            break
          case 'TE':
            item.set({
              top: realTop - item.getScaledHeight(),
              left: realLeft + realWidth / 2 - item.getScaledWidth() / 2,
            })
            break
        }
      })
    }
    // 处理开门方向在xy互换以及逆时针旋转时某些位置的不正确
    handleOpenDoorDistance(Group, info, openDoor.findText)
    const editorBounds = getTypographyEditorBounds(info, rectL, rectT)
    const typographyGroup = new fabric.Group([Group, ...edgeInfoColorTexts], {
      typeName: 'Typography',
      templateRegion: {
        left: scaleSize(editorBounds.left),
        top: scaleSize(editorBounds.top),
      },
      shouldConstrainToCanvas: template.type !== 'plank',
    })
    if (typeof cb === 'function') {
      cb(typographyGroup)
    } else {
      canvas.add(typographyGroup)
    }
  })
}

function rotateKlass(klass, info) {
  if (isRotatePlank && NC_SETTING.xyReverse) {
    klass.rotate(-180)
    rotateChildren(-180)
  } else if (NC_SETTING.xyReverse) {
    klass.rotate(-90)
    rotateChildren(90)
  }

  if (info.rotateDeg || info.rotateDeg == 0) {
    if (NC_SETTING.xyReverse) {
      klass.rotate(info.rotateDeg - 90)
      rotateChildren(360 - info.rotateDeg + 90)
    } else {
      klass.rotate(info.rotateDeg)
      rotateChildren(360 - info.rotateDeg)
    }
  }

  function rotateChildren(a) {
    const ftext = klass.getObjects().filter((it) => it.canRotate)
    ftext.forEach((it) => it.rotate(a))
  }
}

// function countEdgeInfoByJXType(edgeInfo) {
//   if (!JX_CHECKED) return edgeInfo

//   let xyReverse = NC_SETTING.xyReverse ? NC_SETTING.xyReverse : false
//   if (xyReverse) {
//     let copyEdgeV = JSON.parse(JSON.stringify(edgeInfo))[1]
//     edgeInfo[1] = edgeInfo[3]
//     edgeInfo[3] = copyEdgeV
//   } else {
//     let copyEdgeV = JSON.parse(JSON.stringify(edgeInfo))[0]
//     edgeInfo[0] = edgeInfo[2]
//     edgeInfo[2] = copyEdgeV
//   }
//   return edgeInfo
// }
/** 恢复到之前 上面的代码先留着 */
function countEdgeInfoByJXType(part) {
  let edgeInfo = part.edgeInfo.split(/←|↓|→|↑/).filter((v) => v)
  // return edgeInfo
  if (!JX_CHECKED) return edgeInfo

  let xyReverse = NC_SETTING.xyReverse ? NC_SETTING.xyReverse : false

  if (xyReverse) {
    let copyEdgeV = JSON.parse(JSON.stringify(edgeInfo))[1]
    edgeInfo[1] = edgeInfo[3]
    edgeInfo[3] = copyEdgeV
  } else {
    let copyEdgeV = JSON.parse(JSON.stringify(edgeInfo))[0]
    edgeInfo[0] = edgeInfo[2]
    edgeInfo[2] = copyEdgeV
  }

  return edgeInfo
}

/**
 * 根据修边方向 处理L形余料封边
 * @param {*} part 小板
 * @param {*} plank 大板
 * @returns 封边信息
 */
function handleEdgeInfoByTrimSide(part, plank) {
  let edgeInfo = part.edgeInfo
    ? part.edgeInfo.split(/←|↓|→|↑/).filter((v) => v)
    : part
  let copyEdgeInfo = JSON.parse(JSON.stringify(edgeInfo))
  if (plank.surplusInfo && plank.surplusInfo.shape === 'lshape') {
    if (NC_SETTING.xyReverse) {
      if (
        (NC_SETTING.startPosition == '右下角' ||
          NC_SETTING.startPosition == '左上角') &&
        !part.edgeInfo
      ) {
        let copyEdgeV = copyEdgeInfo[0]
        let copyEdgeH = copyEdgeInfo[1]
        let copyEdgeT = copyEdgeInfo[2]
        copyEdgeInfo[0] = copyEdgeT
        copyEdgeInfo[1] = copyEdgeV
        copyEdgeInfo[2] = copyEdgeH
      } else if (
        (NC_SETTING.startPosition == '右上角' ||
          NC_SETTING.startPosition == '左下角') &&
        !part.edgeInfo
      ) {
        let copyEdgeH = copyEdgeInfo[1]
        let copyEdgeT = copyEdgeInfo[2]
        let copyEdgeTT = copyEdgeInfo[3]
        copyEdgeInfo[1] = copyEdgeT
        copyEdgeInfo[2] = copyEdgeTT
        copyEdgeInfo[3] = copyEdgeH
      }
    } else {
      // 高光板只生效右下、左上修边
      if (
        TRIM_SIDE === 'topRight' &&
        !plank.parts[0].is_high_gloss_plank &&
        CODE_PAUSE
      ) {
        let copyEdgeV = copyEdgeInfo[1]
        copyEdgeInfo[1] = copyEdgeInfo[3]
        copyEdgeInfo[3] = copyEdgeV
      } else if (
        TRIM_SIDE === 'bottomLeft' &&
        !plank.parts[0].is_high_gloss_plank &&
        CODE_PAUSE
      ) {
        let copyEdgeV = copyEdgeInfo[0]
        copyEdgeInfo[0] = copyEdgeInfo[2]
        copyEdgeInfo[2] = copyEdgeV
      } else if (TRIM_SIDE === 'topLeft' && CODE_PAUSE) {
        let copyEdgeV = copyEdgeInfo[0]
        let copyEdgeH = copyEdgeInfo[1]
        copyEdgeInfo[0] = copyEdgeInfo[2]
        copyEdgeInfo[1] = copyEdgeInfo[3]
        copyEdgeInfo[2] = copyEdgeV
        copyEdgeInfo[3] = copyEdgeH
      }
    }
  }

  return copyEdgeInfo
}

function drawFiveSixDir(template, part, info) {
  let spin_num = part.rotateNum
  let path = []
  // 获取标签宽高
  let width = scaleSize(mmToPx(template.tag_width, getDeviceXDPI()))
  let height = scaleSize(mmToPx(template.tag_height, getDeviceXDPI()))
  let min = 10,
    max = 40,
    mid = 20,
    top = 0,
    left = 0

  switch (spin_num) {
    // 左下
    case 0:
      path = [
        { x: 0, y: height - max },
        { x: min, y: height - max },
        { x: min, y: height - min },
        { x: max, y: height - min },
        { x: max, y: height },
        { x: 0, y: height },
        { x: 0, y: height - max },
      ]
      top = height - max
      left = 0
      break
    // 左上
    case 1:
      path = [
        { x: 0, y: 0 },
        { x: 0, y: max },
        { x: min, y: max },
        { x: min, y: min },
        { x: max, y: min },
        { x: max, y: 0 },
        { x: 0, y: 0 },
      ]
      top = 0
      left = 0
      break
    // 右上
    case 2:
      path = [
        { x: width - max, y: 0 },
        { x: width, y: 0 },
        { x: width, y: max },
        { x: width - min, y: max },
        { x: width - min, y: min },
        { x: width - max, y: min },
        { x: width - max, y: 0 },
      ]
      top = 0
      left = width - max
      break
    // 右下
    case 3:
      path = [
        { x: width - min, y: height - max },
        { x: width, y: height - max },
        { x: width, y: height },
        { x: width - max, y: height },
        { x: width - max, y: height - min },
        { x: width - min, y: height - min },
        { x: width - min, y: height - max },
      ]
      top = height - max
      left = width - max
      break
    default:
      path = [
        { x: 0, y: height - max },
        { x: min, y: height - max },
        { x: min, y: height - min },
        { x: max, y: height - min },
        { x: max, y: height },
        { x: 0, y: height },
        { x: 0, y: height - max },
      ]
      top = height - max
      left = 0
      break
  }
  // 开启标签反色后 放板基准绘制成白色
  let fill = !GEN_PART_COLOR_REVERT ? '#000' : '#fff'
  return new fabric.Polygon(path, {
    top: top,
    left: left,
    fill,
    selectable: false,
    opacity: 1,
    temName: 'spinDir',
  })
}

/**
 * @description 生成余料标签
 * @param template 模板数据
 * @param cut_part 当前小板
 * @param plank 大板信息
 * @param plank_index 第几张大板
 * @param total_part 总数
 * @param config 配置（放大倍数 scale, 画布颜色 backgroundColor）
 * @param nc_setting this.$store.state.ncSetting
 * @param collect 图片集合
 */
// 生成裁剪板件标签
async function new_createLaveTag(
  template,
  cut_part,
  plank,
  plank_index,
  total_part,
  config = {},
  nc_setting,
  collect,
  label_num
) {
  CONFIG = initConfig(config)
  NC_SETTING = nc_setting || {}
  const isUseSaw = plank.parts.every((part) => part.isUseSaw)
  const { tag_opacity: tagOpacity } = store.state.userPermissions
  // 获取余料边长信息

  cut_part.plankSize = getSurplusSize(cut_part, nc_setting, isUseSaw).str
  if (sessionStorage.getItem('thinkerx_material')) {
    cut_part.plankSize += `*1`
  } else {
    cut_part.plankSize += `*${plank.thick}`
  }
  let canvas_width = template.tag_width
  let canvas_height = template.tag_height
  let rectL = template.rectInfo.left
  let rectT = template.rectInfo.top
  let arrPI = getDeviceXDPI()
  // let plank_scale =
  //   (mmToPx(canvas_height, arrPI) * 2) /
  //   4 /
  //   (NC_SETTING.xyReverse ? plank.plankWidth : plank.plankHeight)
  // 绘制背景
  let my_canvas = new fabric.StaticCanvas(CONFIG.canvas, {
    width: mmToPx(canvas_width, arrPI) * CONFIG.scale,
    height: mmToPx(canvas_height, arrPI) * CONFIG.scale,
    backgroundColor: CONFIG.backgroundColor,
  })
  if (!template?.surplus_data) {
    // 设置为默认模板
    template.surplus_data = JSON.parse(defaultTagData).surplus_tem_data
  }
  await template.surplus_data.forEach(async (item) => {
    let info = item.data
    switch (item.type) {
      case 'FixedText': {
        const fixedText = info.text
        let fixedLeft = (info.left - rectL) * CONFIG.scale
        let fixedTop = (info.top - rectT) * CONFIG.scale
        const newInfo = JSON.parse(JSON.stringify(info))
        Object.assign(newInfo, { left: fixedLeft, top: fixedTop })
        drawTagText(my_canvas, translateTemplateWay(fixedText), newInfo, {
          tagOpacity,
        })
        break
      }
      // 数据来源需要修改
      case 'DataSource': {
        let text = ''
        let textArr = plank.plankSize.split('*')
        if (plank.surplusInfo?.isNotSurplus || !plank.surplusInfo) {
          textArr[0] = plank.plankHeight
          textArr[1] = plank.plankWidth
        }
        let customer_name = [
          ...new Set(
            plank.parts
              .filter((part) => {
                return part.customer_name
              })
              .map((part) => {
                return part.customer_name
              })
          ),
        ].join('/')

        const infoStr = {
          oSize: cut_part.plankSize,
          oSize_L: cut_part.plankSize
            .split('*')
            .splice(0, cut_part.plankSize.split('*').length - 1)
            .join('*'),
          matCode: dealHighlightMatCode(
            cut_part._oriMatCode || cut_part.matCode
          ),
          bigPlankID: plank_index + '',
          plank_index: `第${plank_index}张大板`,
          lable_index: `第${label_num + 1}/${total_part}页`,
          paibanTime: getPaibanTime(),
          oriPlankNum: cut_part.oriPlankNum ?? cut_part.plankNum,
          plankNum: cut_part.plankNum ?? cut_part.oriPlankNum,
          plankSize: `${textArr[1]}*${textArr[0]}*${textArr[2]}`,
          texture:
            cut_part._oriTexture || cut_part.oriTexture || cut_part.texture,
          // 所在余料库
          branch_no:
            ALLSURPLUSLIST.find((surIt) => surIt?.id === cut_part?.branch_id)
              ?.branch_name || '-',
          from_address: cut_part.from_address,
          from_order_num: cut_part.from_order_num,
          matCode_not_high: (cut_part._oriMatCode || cut_part.matCode).replace(
            '高光_',
            ''
          ),
          typesetting_batch: store.state.typesettingBatch || info.text,
          customer_name: customer_name,
          plank_remarks: cut_part.plank_remarks,
        }

        if (info.source_data == 'typesetting_batch') {
          text = store.state.typesettingBatch || info.text
        } else {
          text = infoStr[info.source_data] ?? ''
        }
        if (!text) break

        const { text: str, fontSize: fts } = dealTextStr(
          text,
          info.fontSize,
          info.rectWidth ?? 80,
          info.rectHeight ?? 11.3,
          info.isAutoFontSize ?? true,
          info.lineCount ?? ''
        )
        let Itext = new fabric.Text(translateTemplateWay(str), {
          fontSize: scaleSize(fts),
          selectable: false,
          fontWeight: info.fontWeight,
          left: scaleSize(info.left - rectL),
          top: scaleSize(info.top - rectT),
          fontFamily: getTagFontFamily(info.fontFamily) ?? '微软雅黑',
          lineHeight: info.lineHeight ?? 1,
          opacity: tagOpacity ? info.opacity ?? 1 : 1,
        })
        my_canvas.add(Itext)
        break
      }
      case 'QRcode': {
        //需要判断当前获取的数值是余料入库码还是板件条码
        let url = ''
        if (['oriPlankNum', 'plankNum'].includes(info.source_data)) {
          url = cut_part.plankNum
        } else if (info.source_data == 'restockingCode') {
          const uid = store.state.userInfo.id
          try {
            const plankInfo = buildCutSurplusRestockingQrPlankInfo(
              cut_part,
              nc_setting,
              { uid, page: 1 }
            )
            url = `http://eggi.cn/?plankInfo=${JSON.stringify(plankInfo)}`
          } catch (e) {
            console.error(e)
          }
        } else if (info.source_data === 'simplePlankNum') {
          if (!nc_setting.genSimpleLabelBarcode) break
          url = cut_part.simplePlankNum
        }
        if (!url) break
        // 根据url绘制二维码
        if (info.QRCodeFormat == 'DMCode') {
          let canvas = document.createElement('canvas')
          try {
            BwipJs.toCanvas(canvas, {
              bcid: 'datamatrix', // Barcode type
              text: url, // Text to encode
              scale: 1, // 3x scaling factor
              width: scaleSize(mmToPx(info.mWidth, arrPI)),
              height: scaleSize(mmToPx(info.mHeight, arrPI)),
            })
            const uri = canvas.toDataURL('image/png')
            fabric.Image.fromURL(
              uri,
              (img) => {
                img.set({
                  top: scaleSize(info.top - rectT),
                  left: scaleSize(info.left - rectL),
                  selectable: false,
                })
                my_canvas.add(img)
              },
              {
                scaleX: 0.35, // 缩放
                scaleY: 0.35, // 缩放
              }
            )
          } catch (e) {
            // `e` may be a string or Error object
            console.error(e)
          }
        } else {
          const qrSize = getQrCodeGenSize(info, arrPI)
          await QRCode.toDataURL(url, {
            height: qrSize.height,
            width: qrSize.width,
            margin: 0,
            quality: 1,
            format: 'jpeg',
          }).then((url) => {
            fabric.Image.fromURL(url, (img) => {
              img.set({
                top: scaleSize(info.top - rectT),
                left: scaleSize(info.left - rectL),
                selectable: false,
                scaleX: qrSize.displayW / img.width,
                scaleY: qrSize.displayH / img.height,
              })
              my_canvas.add(img)
            })
          })
        }
        break
      }
      case 'Marking': {
        let radius = scaleSize(info.radius)
        let circle = new fabric.Circle({
          radius,
          fill: '#fff',
          stroke: '#000',
          strokeWidth: 1,
          visible: Boolean(info.realRadius ?? info.mRadius),
        })
        let textFlag = new fabric.IText('余', {
          fontSize: scaleSize(info.fontSize),
          fontWeight: info.fontWeight,
          originX: 'cneter',
          originY: 'cneter',
          left: radius,
          top: radius,
          fontFamily: info.fontFamily ?? '微软雅黑',
        })
        let group = new fabric.Group([circle, textFlag], {
          left: scaleSize(info.left - rectL),
          top: scaleSize(info.top - rectT),
        })
        my_canvas.add(group)
        break
      }
      case 'Typography': {
        let ScaleXCopy = mmToPx(info.mWidth) / plank.plankWidth
        let ScaleYCopy = mmToPx(info.mHeight) / plank.plankHeight
        if (NC_SETTING.xyReverse) {
          ScaleXCopy = mmToPx(info.mWidth) / plank.plankHeight
          ScaleYCopy = mmToPx(info.mHeight) / plank.plankWidth
        }
        let plank_scale = Math.min.apply(null, [ScaleXCopy, ScaleYCopy])
        let oTop = info.top - rectT
        let oLeft = info.left - rectL
        let parts_arr = []
        plank.parts.forEach((part) => {
          if (part.path) {
            let curveHoles = []
            if (part.curveHoles) {
              curveHoles = part.curveHoles
                .filter((it) => it.deep >= part.thick)
                .map((it) => it.path)
            }
            let millInfos = []
            if (part.millInfo) {
              millInfos = part.millInfo
                .filter((it) => it.depth >= part.thick)
                .map((it) => it.shape)
            }
            const resPath = [...part.path, ...curveHoles, ...millInfos]
            resPath.forEach((path, idx) => {
              let dif_shape
              if (idx === 0) {
                let point_arr = path.map((v) => {
                  return {
                    x: (v.x * plank_scale + oLeft) * CONFIG.scale,
                    y: (v.y * plank_scale + oTop) * CONFIG.scale,
                  }
                })
                dif_shape = new fabric.Polygon(point_arr, {
                  top: (part.startY * plank_scale + oTop) * CONFIG.scale,
                  left: (part.startX * plank_scale + oLeft) * CONFIG.scale,
                  stroke: '#000',
                  strokeWidth: 1.5,
                  selectable: false,
                  fill: part.plankNum == cut_part.plankNum ? '#000' : '#fff',
                })
              } else {
                let point_arr = path.map((v) => {
                  return {
                    x:
                      ((part.startX + v.x) * plank_scale + oLeft) *
                      CONFIG.scale,
                    y:
                      ((part.startY + v.y) * plank_scale + oTop) * CONFIG.scale,
                  }
                })
                dif_shape = new fabric.Polygon(point_arr, {
                  stroke: '#000',
                  strokeWidth: 1.5,
                  selectable: false,
                  fill: '#fff',
                })
              }
              parts_arr.push(dif_shape)
            })
          } else {
            let rect_item = new fabric.Rect({
              width: part.rect.width * plank_scale * CONFIG.scale,
              height: part.rect.height * plank_scale * CONFIG.scale,
              top: (part.startY * plank_scale + oTop) * CONFIG.scale,
              left: (part.startX * plank_scale + oLeft) * CONFIG.scale,
              stroke: '#000',
              strokeWidth: 1.5,
              fill: part.plankNum == cut_part.plankNum ? '#000' : '#fff',
              selectable: false,
            })
            parts_arr.push(rect_item)
          }
        })

        let rect
        if (
          plank.surplusInfo &&
          ['lshape', 'specialShape', 1, 2].includes(plank.surplusInfo.shape)
        ) {
          let paths = dealSurplusPlank(
            plank.surplusInfo,
            NC_SETTING,
            plank_scale,
            {
              scale: CONFIG.scale,
              jxChecked: JX_CHECKED,
              plank,
            }
          )
          paths = paths.map((it) => ({
            x: mmToPx(it.x, DPI),
            y: mmToPx(it.y, DPI),
          }))
          rect = new fabric.Polygon(paths, {
            top: oTop * CONFIG.scale,
            left: oLeft * CONFIG.scale,
            selectable: false,
            stroke: '#000',
            strokeWidth: 1.5,
            fill: '#fff',
          })
        } else {
          rect = new fabric.Rect({
            width: plank.plankWidth * plank_scale * CONFIG.scale,
            height: plank.plankHeight * plank_scale * CONFIG.scale,
            top: oTop * CONFIG.scale,
            left: oLeft * CONFIG.scale,
            selectable: false,
            stroke: '#000',
            strokeWidth: 1.5,
            fill: '#fff',
          })
        }
        let groupTop = oTop
        let groupLeft = oLeft
        if (NC_SETTING.xyReverse) {
          groupTop =
            oTop +
            (Math.abs(plank.plankHeight - plank.plankWidth) * plank_scale) / 2
          groupLeft =
            oLeft -
            (Math.abs(plank.plankHeight - plank.plankWidth) * plank_scale) / 2
        }
        // 按照比例处理
        let group = new fabric.Group([rect].concat(parts_arr), {
          width: plank.plankWidth * plank_scale * CONFIG.scale,
          height: plank.plankHeight * plank_scale * CONFIG.scale,
          top: groupTop * CONFIG.scale,
          left: groupLeft * CONFIG.scale,
        })
        rotateKlass(group, info)
        // if (NC_SETTING.xyReverse) group.rotate(-90)
        // if (isRotatePlank) group.rotate(-90)
        // if (NC_SETTING.xyReverse && isRotatePlank) group.rotate(-180)
        my_canvas.add(group)
        group.sendToBack()
        break
      }
      case 'Onecode': {
        const { front_file_identifier } = store.state.ncSetting
        let OneCodeUrl = '',
          plankNumV = '',
          simplePlankNum = cut_part.simplePlankNum
        if (info.source_data === 'oriPlankNum') {
          plankNumV = cut_part.oriPlankNum + front_file_identifier
        } else break
        if (!plankNumV) break
        if (
          nc_setting.genSimpleLabelBarcode &&
          info.source_data !== 'ncName' &&
          info.source_data !== 'remark'
        )
          plankNumV = simplePlankNum
        let codeWidth = 0
        let OSvg = document.createElement('svg')
        let Ocanvas = document.createElement('canvas')
        // 标签数小于等于500时，使用svg
        try {
          JsBarcode(Ocanvas, plankNumV, getOnecodeJsBarcodeOptions(info, arrPI))
          OneCodeUrl = Ocanvas.toDataURL('image/png', 1)
          if (!OneCodeUrl) break
          fabric.Image.fromURL(OneCodeUrl, (img) => {
            img.set({
              top: scaleSize(info.top - rectT),
              left: scaleSize(info.left - rectL),
              ...getOnecodeImageScale(),
              selectable: false,
            })
            /** 重新绘制文字 */
            const textW = scaleSize(mmToPx(info.mWidth, arrPI)) / 4
            const textH = scaleSize(mmToPx(info.mHeight, arrPI)) * 0.85
            plankNumV += ''
            const scaleX = info.mWidth / 32.54
            const scaleY = info.mHeight / 9.52
            const textScale = scaleX < scaleY ? scaleX : scaleY
            let Bartext = new fabric.Text(plankNumV, {
              fontSize: scaleSize(info.fontSize) * textScale,
              selectable: false,
              fontWeight: info.fontWeight === 'bold' ? 'bold' : '',
              top: scaleSize(info.top - rectT) + textH,
              left: scaleSize(info.left - rectL),
              fontFamily: getTagFontFamily(info.fontFamily) ?? '微软雅黑',
            })
            let OnecodeGroup = new fabric.Group([img, Bartext], {
              top: scaleSize(info.top - rectT),
              left: scaleSize(info.left - rectL),
            })
            OnecodeGroup.rotate(info.rotateDeg)
            my_canvas.add(OnecodeGroup)
          })
        } catch (err) {
          console.log('err', err)
          OneCodeUrl = ''
        }
        break
      }
      case 'SurplusSize': {
        // 获取余料各边位置
        let notchDirArr = dealNotchDir(cut_part.surplusPath[0])
        let cutPartDrawPoint = {
          left: (info.left - rectL) * CONFIG.scale,
          top: (info.top - rectT) * CONFIG.scale,
        }
        let cutSizeArr = cut_part.cutSize?.split('*')
        let scaleX = mmToPx(info.mWidth, arrPI) / cutSizeArr[1]
        let scaleY = mmToPx(info.mHeight, arrPI) / cutSizeArr[0]
        let SurplusSizeScale = Math.min.apply(null, [scaleX, scaleY])
        const drawPoint = cut_part.surplusPath[0].map((it) => ({
          x: (it.x * SurplusSizeScale + cutPartDrawPoint.left) * CONFIG.scale,
          y: (it.y * SurplusSizeScale + cutPartDrawPoint.top) * CONFIG.scale,
        }))
        let cut_shape = new fabric.Polygon(drawPoint, {
          top: cutPartDrawPoint.top,
          left: cutPartDrawPoint.left,
          stroke: '#000',
          strokeWidth: 1.5,
          selectable: false,
          fill: '#fff',
        })
        if (isRotatePlank) {
          cut_shape.rotate(-90)
          let arr = []
          const len = notchDirArr.length
          notchDirArr.forEach((it, idx) => {
            let d = JSON.parse(JSON.stringify(it))
            d.text = notchDirArr[(len + idx - 1) % len].text
            arr.push(d)
          })
          notchDirArr = arr
        }
        const diameterR = getPlateKnifeDiameter(
          cut_part.stockKey,
          store.state.ncSetting
        )
        let { width, height } = cut_shape
        let { top: startY, left: startX } = cutPartDrawPoint
        notchDirArr.forEach((it) => {
          let { text, dir } = it
          text =
            parseInt(Number(text).toFixed(2)) -
            (cut_part.blueAreaSurplus ? 0 : diameterR)
          let top, left
          switch (dir) {
            case 'left':
              top = startY + height / 2
              left = startX - 18
              break
            case 'bottom':
              top = startY + height
              left = startX + width / 2
              break
            case 'right':
              top = startY + height / 2
              left = startX + width
              break
            case 'top':
              top = startY - 10
              left = startX + width / 2
              break
            case 'width':
              top = startY + height
              left = startX + width / 2
              break
            case 'height':
              top = startY + height / 2
              left = startX + width
              break
          }
          const textKlass = new fabric.Text(`${text}`, {
            left,
            top,
            fontSize: info.textItems[0].fontSize * CONFIG.scale,
            fontFamily: info.textItems[0].fontFamily,
            fontWeight: info.textItems[0].fontWeight,
          })
          const span = document.createElement('span')
          span.innerText = text
          span.style.fontSize = '12px'
          document.body.append(span)
          const { offsetHeight, offsetWidth } = span
          document.body.removeChild(span)
          if (dir == 'top') {
            textKlass.set({
              top: textKlass.top - offsetHeight,
            })
          }
          if (dir == 'left') {
            textKlass.set({
              left: textKlass.left - offsetWidth,
            })
          }
          if (dir == 'top' || dir == 'bottom') {
            textKlass.set({
              left: textKlass.left - offsetWidth / 2,
            })
          }
          if (dir == 'right') {
            textKlass.set({
              top: textKlass.top - offsetHeight / 2,
            })
          }
          my_canvas.add(textKlass)
        })
        my_canvas.add(cut_shape)
        cut_shape.sendToBack() // 放到最底层
        break
      }
    }
  })
  transformToEzSort.generateExtraDatasources([], {
    part: cut_part,
    plank,
    plank_index,
    total_part,
    template,
    label_num,
  })
  transformToEzSort.addPage()
  return new Promise((resolve) => {
    setTimeout(async () => {
      my_canvas.renderAll()
      setTimeout(async () => {
        let base64
        if (collect) {
          base64 = my_canvas.toDataURL({
            quality: 1,
            multiplier: TAG_EXPORT_MULTIPLIER,
          })
          collect.push(await getTagImageByResolution(base64, NC_SETTING))
        }
        if (CONFIG.type === 'base64')
          resolve(
            base64 ||
              my_canvas.toDataURL({
                quality: 1,
                multiplier: TAG_EXPORT_MULTIPLIER,
              })
          )
        else if (CONFIG.type === 'o_size_base64')
          resolve(
            my_canvas.toDataURL({
              quality: 1,
              format: NC_SETTING.labelImageFormat || 'jpg',
            })
          )
        else resolve(my_canvas.toSVG())
      }, 0)
    }, 10)
  })
}

/**
 * @description 生成余料标签
 * @param template 模板数据
 * @param plank 大板信息
 * @param plank_index 第几张大板
 * @param config 配置（放大倍数 scale, 画布颜色 backgroundColor）
 * @param nc_setting this.$store.state.ncSetting
 */
// 生成废料板件
function createLaveTag(
  template,
  plank,
  plank_index,
  config = {},
  nc_setting,
  collect,
  rotatePlank,
  total_part,
  part_page,
  label_num
) {
  // 可以获取到之前存进去的surplus_data
  isRotatePlank = rotatePlank
  CONFIG = initConfig(config)
  NC_SETTING = nc_setting || {}
  let rectL = template.rectInfo.left
  let rectT = template.rectInfo.top
  let canvas_width = template.tag_width
  let canvas_height = template.tag_height
  let arrPI = getDeviceXDPI()
  const { tag_opacity: tagOpacity } = store.state.userPermissions
  // 获取订单来源号
  // 由于from_order_num 只存在于裁剪板件中， 所以需要兼容没有裁剪板件的情况
  let fromOrderNumArr = []
  let fromOrderNum = ''

  // 判断当前大板上有没有裁剪余料
  const hasCutPart = plank.parts.some((part) => part.surplusPath)
  if (hasCutPart) {
    fromOrderNumArr = plank.parts
      .filter((part) => part.from_order_num)
      .map((part) => part.from_order_num)
  } else {
    fromOrderNumArr = plank.parts
      .filter((part) => part.orderNo)
      .map((part) => part.orderNo)
  }
  fromOrderNum = [...new Set(fromOrderNumArr)].join('/')

  // 获取客户名称
  const customerNameArr = plank.parts
    .filter((part) => part.customer_name)
    .map((part) => part.customer_name)
  const customerName = [...new Set(customerNameArr)].join('/')
  // let plank_scale =
  //   (mmToPx(canvas_height, arrPI) * 2) /
  //   3 /
  //   (NC_SETTING.xyReverse ? plank.plankWidth : plank.plankHeight)
  // 绘制背景
  let my_canvas = new fabric.StaticCanvas(CONFIG.canvas, {
    width: scaleSize(mmToPx(canvas_width, arrPI)),
    height: scaleSize(mmToPx(canvas_height, arrPI)),
    backgroundColor: CONFIG.backgroundColor,
  })
  if (!template?.surplus_waste_data) {
    // 没有废料标签模板 ，则使用余料标签模板
    template.surplus_waste_data = template.surplus_data
  }
  template.surplus_waste_data.forEach((item) => {
    let info = item.data
    let ScaleXCopy = mmToPx(info.mWidth) / plank.plankWidth
    let ScaleYCopy = mmToPx(info.mHeight) / plank.plankHeight
    if (NC_SETTING.xyReverse) {
      ScaleXCopy = mmToPx(info.mWidth) / plank.plankHeight
      ScaleYCopy = mmToPx(info.mHeight) / plank.plankWidth
    }
    let plank_scale = Math.min.apply(null, [ScaleXCopy, ScaleYCopy])
    let fromAddress = [
      ...new Set(
        plank.parts
          .filter((part) => {
            return part.address
          })
          .map((part) => {
            return part.address
          })
      ),
    ].join('/')
    switch (item.type) {
      case 'FixedText': {
        const fixedText = info.text
        let fixedLeft = (info.left - rectL) * CONFIG.scale
        let fixedTop = (info.top - rectT) * CONFIG.scale
        const newInfo = JSON.parse(JSON.stringify(info))
        Object.assign(newInfo, { left: fixedLeft, top: fixedTop })
        drawTagText(my_canvas, translateTemplateWay(fixedText), newInfo, {
          tagOpacity,
        })
        break
      }
      case 'DataSource': {
        let text = ''
        // 处理DataSouce数据
        const infoStr = {
          oSize: '',
          oSize_L: '',
          matCode: dealHighlightMatCode(plank._oriMatCode || plank.matCode),
          bigPlankID: plank_index + '',
          plank_index: `第${plank_index}张大板`,
          lable_index: `第${label_num + 1}/${total_part}页`,
          paibanTime: getPaibanTime(),
          oriPlankNum: '',
          plankSize: `${plank.plankHeight}*${plank.plankWidth}*${plank.thick}`,
          texture: plank._oriTexture || plank.oriTexture || plank.texture,
          branch_no: '-',
          from_address: fromAddress,
          from_order_num: fromOrderNum,
          matCode_not_high: (plank._oriMatCode || plank.matCode).replace(
            '高光_',
            ''
          ),
          typesetting_batch: store.state.typesettingBatch || info.text,
          customer_name: customerName,
        }
        if (info.source_data == 'typesetting_batch') {
          text = store.state.typesettingBatch || info.text
        } else {
          text = infoStr[info.source_data] ?? ''
        }
        if (!text) break

        const { text: str, fontSize: fts } = dealTextStr(
          text,
          info.fontSize,
          info.rectWidth ?? 80,
          info.rectHeight ?? 11.3,
          info.isAutoFontSize ?? true,
          info.lineCount ?? ''
        )
        let Itext = new fabric.Text(translateTemplateWay(str), {
          fontSize: scaleSize(fts),
          selectable: false,
          fontWeight: info.fontWeight,
          left: scaleSize(info.left - rectL),
          top: scaleSize(info.top - rectT),
          fontFamily: getTagFontFamily(info.fontFamily) ?? '微软雅黑',
          lineHeight: info.lineHeight ?? 1,
          opacity: tagOpacity ? info.opacity ?? 1 : 1,
        })
        my_canvas.add(Itext)
        break
      }
      // 废料标签的二维码
      case 'QRcode': {
        let url = ''
        if (info.source_data == 'restockingCode') {
          const highgloss_directionMap = {
            front: 1,
            back: 2,
          }
          let uid = store.state.userInfo.id
          let page = 2
          let shape = 2
          let plankInfo = {
            uid,
            m: dealHighlightMatCode(plank._oriMatCode || plank.matCode),
            t: plank._oriTexture || plank.oriTexture || plank.texture,
            s: `${page}-${plank.thick}-${shape}`,
            p: plank.plankNum,
            d: plank.texDir,
            h:
              highgloss_directionMap[
                store.state.ncSetting.highgloss_direction
              ] ?? 0,
          }
          url = `http://eggi.cn/?plankInfo=${JSON.stringify(plankInfo)}`
        }
        if (!url) break
        // 根据url绘制二维码
        if (info.QRCodeFormat == 'DMCode') {
          let canvas = document.createElement('canvas')
          try {
            BwipJs.toCanvas(canvas, {
              bcid: 'datamatrix', // Barcode type
              text: url, // Text to encode
              scale: 1, // 3x scaling factor
              width: scaleSize(mmToPx(info.mWidth, arrPI)),
              height: scaleSize(mmToPx(info.mHeight, arrPI)),
            })
            const uri = canvas.toDataURL('image/png')
            fabric.Image.fromURL(
              uri,
              (img) => {
                img.set({
                  top: scaleSize(info.top - rectT),
                  left: scaleSize(info.left - rectL),
                  selectable: false,
                })
                my_canvas.add(img)
              },
              {
                scaleX: 0.35, // 缩放
                scaleY: 0.35, // 缩放
              }
            )
          } catch (e) {
            // `e` may be a string or Error object
            console.error(e)
          }
        } else {
          const qrSize = getQrCodeGenSize(info, arrPI)
          QRCode.toDataURL(url, {
            height: qrSize.height,
            width: qrSize.width,
            margin: 0,
            quality: 1,
            format: 'jpeg',
          }).then((url) => {
            fabric.Image.fromURL(url, (img) => {
              img.set({
                top: scaleSize(info.top - rectT),
                left: scaleSize(info.left - rectL),
                scaleX: qrSize.displayW / img.width,
                scaleY: qrSize.displayH / img.height,
                selectable: false,
              })
              my_canvas.add(img)
            })
          })
        }

        break
      }
      case 'Marking': {
        let radius = scaleSize(info.radius)
        const realRadius = info.realRadius
        let circle = new fabric.Circle({
          radius,
          fill: '#fff',
          stroke: '#000',
          strokeWidth: 1,
          visible: Boolean(realRadius ?? info.mRadius),
        })
        let textFlag = new fabric.IText('余', {
          fontSize: scaleSize(info.fontSize),
          fontWeight: info.fontWeight,
          originX: 'cneter',
          originY: 'cneter',
          left: radius,
          top: radius,
          fontFamily: info.fontFamily ?? '微软雅黑',
        })
        let group = new fabric.Group([circle, textFlag], {
          left: scaleSize(info.left - rectL),
          top: scaleSize(info.top - rectT),
        })
        my_canvas.add(group)

        break
      }
      case 'Typography': {
        let oTop = info.top - rectT
        let oLeft = info.left - rectL
        // mmToPx(canvas_width, arrPI) -
        //   (NC_SETTING.xyReverse ? plank.plankHeight : plank.plankWidth) *
        //     plank_scale -
        //   12
        let parts = plank.parts
        let parts_arr = []
        parts.forEach((part) => {
          if (part.path) {
            let point_arr = part.path[0].map((v) => {
              return {
                x: scaleSize(v.x * plank_scale + oLeft),
                y: scaleSize(v.y * plank_scale + oTop),
              }
            })
            let dif_shape = new fabric.Polygon(point_arr, {
              top: scaleSize(part.startY * plank_scale + oTop),
              left: scaleSize(part.startX * plank_scale + oLeft),
              stroke: '#000',
              strokeWidth: 1,
              selectable: false,
              fill: '#fff',
            })
            parts_arr.push(dif_shape)
          } else {
            let rect_item = new fabric.Rect({
              width: scaleSize(part.rect.width * plank_scale),
              height: scaleSize(part.rect.height * plank_scale),
              top: scaleSize(part.startY * plank_scale + oTop),
              left: scaleSize(part.startX * plank_scale + oLeft),
              stroke: '#fff',
              strokeWidth: 1,
              fill: '#fff',
              selectable: false,
            })
            parts_arr.push(rect_item)
          }
        })

        const surplusInfo = plank.surplusInfo
        let rect = null
        if (surplusInfo && surplusInfo.path && surplusInfo.path.length > 0) {
          const paths = dealPathByNCSetting(
            surplusInfo.path.map((item) => ({
              x: scaleSize(item.x * plank_scale),
              y: scaleSize(item.y * plank_scale),
            })),
            NC_SETTING
          )
          rect = new fabric.Polygon(paths, {
            top: scaleSize(oTop),
            left: scaleSize(oLeft),
            selectable: false,
            stroke: '#000',
            strokeWidth: 1,
            fill: '#000',
          })
        } else {
          rect = new fabric.Rect({
            width: scaleSize(plank.plankWidth * plank_scale),
            height: scaleSize(plank.plankHeight * plank_scale),
            top: scaleSize(oTop),
            left: scaleSize(oLeft),
            selectable: false,
            stroke: '#000',
            strokeWidth: 1,
            fill: '#000',
          })
        }
        let groupTop = oTop
        let groupLeft = oLeft
        if (NC_SETTING.xyReverse) {
          groupTop =
            oTop +
            (Math.abs(plank.plankHeight - plank.plankWidth) * plank_scale) / 2
          groupLeft =
            oLeft -
            (Math.abs(plank.plankHeight - plank.plankWidth) * plank_scale) / 2
        }
        let group = new fabric.Group([rect].concat(parts_arr), {
          width: scaleSize(plank.plankWidth * plank_scale),
          height: scaleSize(plank.plankHeight * plank_scale),
          top: scaleSize(groupTop),
          left: scaleSize(groupLeft),
        })
        rotateKlass(group, info)
        my_canvas.add(group)
        group.sendToBack()
        break
      }
      case 'Onecode': {
        break
      }
      case 'SurplusSize': {
        break
      }
    }
  })
  transformToEzSort.addPage()
  return new Promise((resolve) => {
    setTimeout(async () => {
      my_canvas.renderAll()
      let base64
      if (collect) {
        base64 = my_canvas.toDataURL({
          quality: 1,
          multiplier: TAG_EXPORT_MULTIPLIER,
        })
        collect.push(await getTagImageByResolution(base64, NC_SETTING))
      }
      setTimeout(() => {
        if (CONFIG.type === 'base64')
          resolve(
            base64 ||
              my_canvas.toDataURL({
                quality: 1,
                multiplier: TAG_EXPORT_MULTIPLIER,
              })
          )
        else if (CONFIG.type === 'o_size_base64')
          resolve(
            my_canvas.toDataURL({
              quality: 1,
              format: NC_SETTING.labelImageFormat || 'jpg',
            })
          )
        else resolve(my_canvas.toSVG())
      }, 0)
    }, 10)
  })
}

function drawSignRect(current, my_canvas) {
  let { top, left, width, height, rectL, rectT } = current
  let dpi = getDeviceXDPI()
  const k = pxTomm(60, dpi)

  let rect = new fabric.Rect({
    left: scaleSize(left - rectL) - k / 2,
    top: scaleSize(top - rectT) - k / 2,
    width: width + k,
    stroke: '#000',
    strokeWidth: 2,
    fill: 'transparent',
    height: height + k,
  })
  my_canvas.add(rect)
}

// 根据svg的条形码信息，把条形码绘制到canvas上面
function drawBarCodeSvgInCanvas(
  svgXml,
  CONFIG = {
    scale: 1,
    left: 0,
    // y,
    top: 0,
  },
  cb
) {
  // let svgXml = document.querySelector('#barcode')
  // 获取所有g
  let gList = svgXml.querySelectorAll('g')
  let rectList = []
  if (gList.length > 1) {
    // 在ean13里面有多个g元素，每个g元素都有自己的translate。它下面的rect元素的x属性都是基于g来计算的
    gList.forEach((g) => {
      let reg = /translate\((\d+\.?\d*), 0\)/
      let translateX = g.outerHTML.match(reg)[1]
      // g下面的rect
      let gRectList = g.querySelectorAll('rect')
      gRectList.forEach((item) => {
        item.setAttribute('data-translateX', translateX)
      })
    })
  }
  rectList = svgXml.querySelectorAll('g > rect')
  let firstLeft, finalleft, finalWidth
  const rectArr = []
  rectList.forEach((item, index) => {
    let reg =
      /<rect x="(\d+\.?\d*)" y="(\d+\.?\d*)" width="(\d+\.?\d*)" height="(\d+\.?\d*)"/
    let result = item.outerHTML.match(reg)
    let rectPos = {}
    if (result.length) {
      let translateX = +(item.dataset.translateX || 0)
      rectPos.x = +result[1] + translateX
      rectPos.y = +result[2]
      rectPos.width = +result[3]
      rectPos.height = +result[4]
    }
    let left = CONFIG.left + rectPos.x
    var rect = new fabric.Rect({
      width: rectPos.width * 0.9, // 让每条的宽度小一点，在不影响使用的情况下，避免打印的时候多条线连接在一起
      height: CONFIG.height || rectPos.height,
      stroke: '#000',
      fill: '#000',
      top: CONFIG.top + rectPos.y,
      left: left,
      strokeWidth: 0,
      selectable: false,
    })
    if (index === 0) {
      firstLeft = left
    } else if (index === rectList.length - 1) {
      finalleft = left
      finalWidth = rectPos.width
    }
    rectArr.push(rect)
  })
  if (typeof cb === 'function') {
    cb(rectArr)
  }
  return finalleft - firstLeft + finalWidth
}
/**
 *
 * @param {*} sSlots 侧孔
 * @param {*} sholesL 侧槽
 */
export function judgePtpNeedBackNum(sSlots, sholesL) {
  const process_setting_id = store.state.ncSetting.process_setting_id
  const processInfo = store.state.proLineList.find(
    (item) => process_setting_id === item.id
  )
  let isNeedBackNum = false
  // 如果是ptp并且有侧孔或者侧槽时
  if (processInfo && Object.keys(processInfo).length) {
    const isPtp = processInfo.data?.ptpHoleDrill
    if (isPtp && (sSlots || sholesL)) {
      isNeedBackNum = true
    }
  }
  return isNeedBackNum
}

// 房间名字与字母的映射关系
const roomNameToChartMap = (roomList) => {
  if (!roomList.length) return

  const result = {}
  // 房间名字与字母的映射关系
  // const roomNameMap = new Map()
  // // 柜体名和数字的映射关系
  // const cabinetNumMap = new Map()
  // 统计房间出现次数,26个房间以内时对应A-Z，如果超过26个房间，则对应AA-AZ,然后是BA-AZ,CA-CZ,DA-DZ
  const generateChart = () => {
    let firstChart = ''
    let secondChartCode = 65
    let secondChart = ''
    let result = ''
    return () => {
      if (secondChartCode === 'Z'.charCodeAt()) {
        result = firstChart + String.fromCharCode(secondChartCode)
        if (!firstChart) {
          firstChart = 'A'
        } else {
          firstChart = String.fromCharCode(firstChart.charCodeAt() + 1)
        }
        secondChartCode = 65
        secondChart = String.fromCharCode(secondChartCode)
      } else {
        secondChart = String.fromCharCode(secondChartCode)
        secondChartCode++
        result = firstChart + secondChart
      }
      return result
    }
  }

  const genChartFn = generateChart()

  // 生成递增的数字序号
  const generateOrderNum = () => {
    let orderNum = 1
    return () => orderNum++
  }
  const generateOrderNumFn = generateOrderNum()

  // 生成房间号
  const generateValue = () => {
    return [genChartFn(), generateOrderNumFn()]
  }
  roomList.forEach((item) => {
    let { roomName, loc, orderNo } = item.part
    // let roomName = item.part.roomName
    // let loc = item.part.loc
    // if (!orderNo) return
    if (!orderNo) {
      orderNo = ''
    }
    if (!result[orderNo]) {
      result[orderNo] = [new Map(), new Map()]
    }
    if (roomName) {
      if (!result[orderNo][0].has(roomName)) {
        result[orderNo][0].set(roomName, generateValue())
      }
      if (!result[orderNo][1].has(roomName)) {
        result[orderNo][1].set(roomName, [loc])
      } else {
        const current = result[orderNo][1].get(roomName)
        // 判断当前柜体是已存在
        const isExist = current.find((it) => it === loc)
        // 不存在，将该柜体加入，并且初始化柜体号
        if (!isExist) {
          current.push(loc)
        }
      }
    }
  })
  return result
}

// 根据计算好的房间编号，柜体编号，返回对应的标签标记
const getPartFlag = (
  { field, roomSortWay, part },
  { roomName, loc },
  roomAndCabinetMap
) => {
  let { orderNo } = part
  let textValue = ''
  if (field === 'wardrobeNum') {
    textValue = part[field] ?? '面'
  } else if (field === 'isFrontPlank') {
    if (!part[field]) {
      textValue = ''
    } else {
      //面板标记
      textValue = '面'
    }
  } else {
    if (!roomAndCabinetMap) return
    // 解构出房间编号，柜体编号
    // const { roomNameMap, cabinetNumMap } = roomAndCabinetMap
    // 然后将数组第一项删除
    let roomChart = ''
    orderNo = orderNo || ''
    if (roomSortWay === 'letters') {
      roomChart = roomAndCabinetMap[orderNo][0].get(roomName)[0]
    } else {
      roomChart = roomAndCabinetMap[orderNo][0].get(roomName)[1]
    }
    const cabinet = roomAndCabinetMap[orderNo][1].get(roomName)
    // 找出对应的柜体编号
    const cabinetNumIndex = cabinet.findIndex((item) => item === loc)
    textValue = `${roomChart}-${cabinetNumIndex + 1}`
  }

  return textValue
}
// 绘制彩色矩形块
function drawColorRect(top, left, width, height, fillColor, canvas) {
  let rect = new fabric.Rect({
    top,
    left,
    width,
    height,
    fill: fillColor,
    typeName: 'ColorTagBackground',
  })
  canvas.add(rect)
  // 放到画布最底层
  rect.sendToBack()
}
// 数据计数
function incrementCount(part, map, key) {
  // 同订单只需要判断订单号 同房间需要判断：订单-房间 同柜体需要判断：订单-房间-柜体
  let keyName = ''
  if (key == 'roomName') {
    keyName = `${part.orderNo ?? ''}-${part.roomName ?? ''}`
  } else if (key == 'loc') {
    keyName = `${part.orderNo ?? ''}-${part.roomName ?? ''}-${part.loc ?? ''}`
  } else {
    keyName = part[key] ?? ''
  }
  if (map[keyName]) {
    map[keyName]++
  } else {
    map[keyName] = 1
  }
}

// 同尺寸小板总计
function countSameSizeBoard(arr) {
  /*  
    最后得到的形式暂定是这样
    { 
      "500*300": 
        {
          "不限": 10,
          "同订单": {guiA:10},
          "同房间": {roomA:10},
          "同柜体": {wardrobe:10}
        }
    }
  */
  const statisticsCount = {}
  const criteriaClassifiction = ['sameOrder', 'sameRoom', 'sameWardrobe']
  for (let statisticsPart of arr) {
    // 首先判断小板/余料板 通过surplusPath判断
    if (!statisticsPart.part || statisticsPart.part.surplusPath) {
      continue
    }
    let part = statisticsPart.part
    // 判断当前小板是否是矩形轮廓
    // 如果小板有path字段标识当前小板是异形板，需要判断小板是否是存在内部异形的矩形轮廓板
    // （外轮廓可为多点，边上共线点仍可能是矩形）
    if (part.path) {
      let path = cloneDeep(part.path[0])
      path.splice(-1)
      if (!judgeRectangle(path)) continue
    }
    // 将数据形式统一更改成长边*短边，不需要考虑纹理
    const oRect = part.oRect
    // 当前小板的数据 小板的size用成品尺寸去处理，用oRect
    // 获取需要被统计的尺寸statisticsSize
    let statisticsSize =
      oRect.height > oRect.width
        ? `${oRect.height}*${oRect.width}`
        : `${oRect.width}*${oRect.height}`
    if (!statisticsCount[statisticsSize]) {
      // 默认初始值为空对象
      statisticsCount[statisticsSize] = {}
      // 除不限外的其余统计方式赋初始值
      for (let key of criteriaClassifiction) {
        statisticsCount[statisticsSize][key] = {}
      }
      // 不限
      statisticsCount[statisticsSize]['noLimit'] = 0
    }
    statisticsCount[statisticsSize]['noLimit']++
    incrementCount(
      part,
      statisticsCount[statisticsSize]['sameOrder'],
      'orderNo'
    )
    incrementCount(
      part,
      statisticsCount[statisticsSize]['sameRoom'],
      'roomName'
    )
    incrementCount(part, statisticsCount[statisticsSize]['sameWardrobe'], 'loc')
  }
  return statisticsCount
}

/**
 * 获取大板绘制轮廓路径
 * @param {*} bigPlank 大板
 * @param {*} options 选项
 * @returns
 */
function getBigPlankDrawOutlinePath(bigPlank, options) {
  const { JX_CHECKED, xyReverse } = options
  let nPath = window.$copy(bigPlank.path ?? [])
  if (JX_CHECKED) {
    const [minX, minY, maxX, maxY] = getPathMinMaxPoint(nPath)
    const width = maxX - minX
    const height = maxY - minY
    // 翻转时开启 xy 互换的情况下翻转是不一样的(和其他地方的逻辑相同)
    nPath = nPath.map((item) => {
      return {
        x: !xyReverse ? width - item.x : item.x,
        y: !xyReverse ? item.y : height - item.y,
      }
    })
  }
  return nPath
}

/**
 * 获取L型余料大板 四周要绘制的边长信息数据格式等同封边
 * @param {*} path 路径
 * @returns 轮廓信息
 */
function getLShapeOutlineInfo(path) {
  const lOutlineInfo = getEdgeLengthsFromLShape(path ?? [])
  const edgeInfo = []
  const map = {
    left: 0,
    right: 2,
    top: 3,
    bottom: 1,
  }
  Object.values(lOutlineInfo).forEach((val) => {
    edgeInfo[map[val.direction]] = toDecimal(val.size, 2)
  })
  return edgeInfo.map((item) => toDecimal(item, 1))
}
/**
 * 获取大板标签的周边尺寸信息
 * @param {*} path 路径
 * @param {*} xyReverse
 * @returns
 */
function getPlankOutlineInfo(path, xyReverse) {
  const [minX, minY, maxX, maxY] = getPathMinMaxPoint(path)
  const width = toDecimal(maxX - minX, 2)
  const height = toDecimal(maxY - minY, 2)
  return xyReverse ? [height, '', '', width] : [height, width, '', '']
}

export {
  createTag,
  createLaveTag,
  roomNameToChartMap,
  getPartFlag,
  countSameSizeBoard,
  handleEdgeInfoByTrimSide,
}

/**
 * 解析封边字符串和板件尺寸，返回封边类型
 * @param {string} edgeInfoStr 例如 "←0.5↓0.5→1.5↑0.5" 或 "←0.5↓0.5→↑0.5" 或 "←0.5↓0.5↑0.5"
 * @param {object} rect 例如 {height:1236.08,width:570}
 * @returns {string} 封边类型
 */
const numMap = { 1: '一', 2: '二', 3: '三', 4: '四' }
// 定义相邻边的组合
const adjacentPairs = [
  ['left', 'up'],
  ['up', 'right'],
  ['right', 'down'],
  ['down', 'left'],
  ['left', 'down'],
  ['down', 'right'],
  ['right', 'up'],
  ['up', 'left'],
]
export function getEdgeTypeWithRect(edgeInfoStr, rect) {
  // 初始化四个方向的封边值
  let left = 0,
    down = 0,
    right = 0,
    up = 0

  // 分别匹配每个方向的封边信息
  const leftMatch = edgeInfoStr.match(/←([\d.]+)/)
  const downMatch = edgeInfoStr.match(/↓([\d.]+)/)
  const rightMatch = edgeInfoStr.match(/→([\d.]+)/)
  const upMatch = edgeInfoStr.match(/↑([\d.]+)/)

  // 如果匹配到则赋值，否则保持默认值0
  if (leftMatch) left = Number(leftMatch[1])
  if (downMatch) down = Number(downMatch[1])
  if (rightMatch) right = Number(rightMatch[1])
  if (upMatch) up = Number(upMatch[1])

  const edgeList = [
    { dir: 'left', valid: left > 0, size: rect.height },
    { dir: 'down', valid: down > 0, size: rect.width },
    { dir: 'right', valid: right > 0, size: rect.height },
    { dir: 'up', valid: up > 0, size: rect.width },
  ]

  const validEdges = edgeList.filter((e) => e.valid)
  if (validEdges.length === 0) return '无封边'

  // 进行长短判断
  const validSizes = edgeList.map((e) => e.size)
  const max = Math.max(...validSizes)
  const min = Math.min(...validSizes)

  // 标记每条有效边的长短类型
  validEdges.forEach((e) => {
    e.type = e.size === max ? '长' : '短'
  })

  const total = validEdges.length
  // 只要是四边封边，直接返回'两长两短'
  if (total === 4) return '两长两短'

  const longCount = validEdges.filter((e) => e.type === '长').length
  const shortCount = validEdges.filter((e) => e.type === '短').length
  if (total === 3) {
    // 三边封边
    if (longCount >= 2) {
      // 有两边是长边（三边相等情况也做此逻辑处理）
      return '两长一短'
    } else {
      return '两短一长'
    }
  }
  if (total === 2) {
    // 当两条边长度相等时，判断是否为相邻边
    // 获取有效边的方向
    const validDirections = validEdges.map((e) => e.dir)

    // 检查是否为相邻边
    const isAdjacent = adjacentPairs.some(
      (pair) =>
        validDirections.includes(pair[0]) && validDirections.includes(pair[1])
    )
    if (max === min) {
      if (isAdjacent) {
        // 相邻边 且 等长
        return '一长一短'
      } else {
        // 不相邻边 且 等长
        return '两长'
      }
    } else {
      // 两条边 且 不等长
      if (isAdjacent) {
        // 相邻边 且 不等长
        return '一长一短'
      } else {
        // 不相邻边 且 不等长
        if (longCount) {
          return '两长'
        } else {
          return '两短'
        }
      }
    }
  }
  if (total === 1) {
    if (longCount === total) return `${numMap[total]}长`
    if (shortCount === total) return `${numMap[total]}短`
  }
  // 兜底：返回具体的长短分布 理论上不会出现
  const typeStr = validEdges.map((e) => e.type).join('')
  return typeStr
}

/**
 * 解析见光边字符串：←1.0↓0→2↑0 → 数值非 0 的方向为 true
 * @param {string} lightEdgeInfoStr
 * @returns {{ isLeft: boolean, isDown: boolean, isRight: boolean, isUp: boolean }}
 */
function parseLightEdgeDirections(lightEdgeInfoStr) {
  const leftVal = Number(lightEdgeInfoStr.match(/←([\d.]+)/)?.[1] || 0)
  const downVal = Number(lightEdgeInfoStr.match(/↓([\d.]+)/)?.[1] || 0)
  const rightVal = Number(lightEdgeInfoStr.match(/→([\d.]+)/)?.[1] || 0)
  const upVal = Number(lightEdgeInfoStr.match(/↑([\d.]+)/)?.[1] || 0)
  return {
    isLeft: leftVal !== 0,
    isDown: downVal !== 0,
    isRight: rightVal !== 0,
    isUp: upVal !== 0,
  }
}

/**
 * 解析前封边字符串：含对应箭头即为该方向
 * @param {string} edgeStr
 * @returns {{ isLeft: boolean, isDown: boolean, isRight: boolean, isUp: boolean }}
 */
function parseArrowEdgeDirections(edgeStr) {
  return {
    isLeft: edgeStr.includes('←'),
    isDown: edgeStr.includes('↓'),
    isRight: edgeStr.includes('→'),
    isUp: edgeStr.includes('↑'),
  }
}

/**
 * 绘制见光边 / 前封边标识并加入画布（公共逻辑）
 * @param {object} options
 * @param {fabric.Canvas} options.canvas
 * @param {object} options.info 控件数据
 * @param {number} options.rectL
 * @param {number} options.rectT
 * @param {{ isLeft: boolean, isDown: boolean, isRight: boolean, isUp: boolean }} options.directions
 * @param {number} options.rotateDeg
 * @param {'VisibleEdge' | 'FrontEdge'} options.typeName 组 typeName，子元素为 `${typeName}Base/Arrow`
 */
function addEdgeIndicatorGroup({
  canvas,
  info,
  rectL,
  rectT,
  directions,
  rotateDeg,
  typeName,
}) {
  const result = rotateDirections(
    directions.isLeft,
    directions.isDown,
    directions.isRight,
    directions.isUp,
    rotateDeg
  )
  if (!result.isUp && !result.isDown && !result.isLeft && !result.isRight) {
    return
  }

  const left = scaleSize(info.left - rectL)
  const top = scaleSize(info.top - rectT)
  const triangleSize = info.triangleSize * info.scaleX * 2 || 12
  // 编辑页放大 2 倍：分别减去箭头高*2、间距*2、边框*1
  const width = info.width * info.scaleX * 2 - triangleSize * 2 - 3
  const height = info.height * info.scaleY * 2 - triangleSize * 2 - 3
  const edgeStyle = info.visibleEdgeOrFrontEdgeStyle || 'triangle'
  const baseTypeName = `${typeName}Base`
  const arrowTypeName = `${typeName}Arrow`
  const ArrowCtor = edgeStyle === 'triangle' ? fabric.Triangle : fabric.Rect

  const edgeItems = []
  edgeItems.push(
    new fabric.Rect({
      left: 0,
      top: 0,
      width,
      height,
      fill: 'rgba(0,0,0,0)',
      stroke: 'rgba(0,0,0,.2)',
      strokeWidth: 1,
      selectable: false,
      evented: false,
      opacity: 0,
      typeName: baseTypeName,
    })
  )

  const topArrow = new ArrowCtor({
    left: width / 2 + 0.5,
    top: -triangleSize / 2 - 1,
    width: triangleSize,
    height: triangleSize,
    fill: GEN_PART_COLOR_REVERT ? '#fff' : '#000000',
    selectable: false,
    typeName: arrowTypeName,
    hasControls: false,
    originX: 'center',
    originY: 'center',
    position: 'top',
    opacity: result.isUp ? 1 : 0,
  })
  edgeItems.push(topArrow)

  const bottomArrow = fabric.util.object.clone(topArrow)
  bottomArrow.set({
    top: height + triangleSize / 2 + 1 + 1,
    angle: 180,
    position: 'bottom',
    opacity: result.isDown ? 1 : 0,
  })
  edgeItems.push(bottomArrow)

  const leftArrow = fabric.util.object.clone(topArrow)
  leftArrow.set({
    left: -triangleSize / 2 - 1,
    top: height / 2 + 0.5,
    angle: -90,
    position: 'left',
    opacity: result.isLeft ? 1 : 0,
  })
  edgeItems.push(leftArrow)

  const rightArrow = fabric.util.object.clone(topArrow)
  rightArrow.set({
    left: width + triangleSize / 2 + 1 + 1,
    top: height / 2 + 0.5,
    angle: 90,
    position: 'right',
    opacity: result.isRight ? 1 : 0,
  })
  edgeItems.push(rightArrow)

  canvas.add(
    new fabric.Group(edgeItems, {
      left,
      top,
      selectable: true,
      hasControls: true,
      typeName,
      originX: 'left',
      originY: 'top',
      triangleSize,
      visibleEdgeOrFrontEdgeStyle: edgeStyle,
    })
  )
}

/**
 * 根据旋转角度调整四个方向的布尔值
 * @param {boolean} isLeft - 左方向布尔值
 * @param {boolean} isDown - 下方向布尔值
 * @param {boolean} isRight - 右方向布尔值
 * @param {boolean} isUp - 上方向布尔值
 * @param {number} rotateDeg - 旋转角度 (0, 90, 180, 270)
 * @returns {object} 返回旋转后的四个方向布尔值
 */
function rotateDirections(isLeft, isDown, isRight, isUp, rotateDeg) {
  // 将四个方向的布尔值转换为数组，便于旋转操作
  let directions = [isLeft, isDown, isRight, isUp]

  // 优先进行xy轴互换逻辑 该逻辑是根据tag-draw.js的getCutDirEdge（就是逆时针旋转90度）
  if (NC_SETTING.xyReverse) {
    // xy轴互换：
    // [左, 下, 右, 上] -> [上, 左, 下, 右]
    directions = [directions[3], directions[0], directions[1], directions[2]]
  }
  // 根据旋转角度进行顺时针旋转 便于理解 暂时保留
  // switch (rotateDeg) {
  //   case 0:
  //     // 不旋转，保持原值
  //     break;
  //   case 90:
  //     // 顺时针旋转90度：[左, 下, 右, 上] -> [下, 右, 上, 左]
  //     directions = [directions[1], directions[2], directions[3], directions[0]];
  //     break;
  //   case 180:
  //     // 顺时针旋转180度：[左, 下, 右, 上] -> [右, 上, 左, 下]
  //     directions = [directions[2], directions[3], directions[0], directions[1]];
  //     break;
  //   case 270:
  //     // 顺时针旋转270度：[左, 下, 右, 上] -> [上, 左, 下, 右]
  //     directions = [directions[3], directions[0], directions[1], directions[2]];
  //     break;
  //   default:
  //     console.warn('不支持的旋转角度:', rotateDeg);
  //     break;
  // }
  // 优化上面逻辑
  const rotateCount = Math.floor(rotateDeg / 90)
  for (let i = 0; i < rotateCount; i++) {
    directions = directions.slice(1).concat(directions[0])
  }

  return {
    isLeft: directions[0],
    isDown: directions[1],
    isRight: directions[2],
    isUp: directions[3],
  }
}

/** @description 双语标签用户是否设置此字段需要翻译 */
export function isDualLanguageTagUserSetTranslate(templateField) {
  const { dualLanguageTags } = store.state.preferencesSetting.setting
  return templateField && dualLanguageTags.includes(templateField)
}
